export default {
  translation: {
    CHECK_EMAIL_TITLE: "Revisar correo electrónico",
    WELCOME_BACK: "¡Bienvenido/a de nuevo!",
    ENTER_YOUR_CREDENTIALS: "Introduce tus credenciales para continuar",
    EMAIL_FIELD: "Correo electrónico",
    CHECK_BUTTON: "Revisar",
    EMAIL_IS_REQUIRED: "Correo electrónico obligatorio",
    CREATE_PASSWORD_TITLE: "Crear contraseña",
    SUBMIT_BUTTON: "Enviar",
    LOGIN_TITLE: "Iniciar sesión",
    PASSWORD_FIELD: "Contraseña",
    PLEASE_INPUT_YOUR_PASSWORD: "Introduce tu contraseña",
    FORGOT_PASSWORD: "¿Has olvidado tu contraseña?",
    REMEMBER_ME: "Recuérdame",
    LOGIN_TO_ACCOUNT_BUTTON: "Iniciar sesión en la cuenta",
    SIDEBAR_ORDER_HISTORY: "Historial de pedidos",
    SIDEBAR_SIGNOUT: "Cerrar sesión",
    FOOTER_MENU_HOME: "Inicio",
    FOOTER_MENU_SHARE: "Compartir",
    FOOTER_MENU_KWIKCASH: "KwikCash",
    FOOTER_MENU_HISTORY: "Historial",
    SHARE_THE_PRODUCTS_TITLE: "Compartir los productos",
    PLEASE_SELECT_A_CAMPAIGN_TO_SHARE:
      "Selecciona los productos para los que te gustaría crear un enlace",
    CREATE_A_KWIKLINK_BUTTON: "Crear un KwikLink",
    MANAGE_MY_KWIKLINKS: "Administrar mis KwikLinks",
    KWIK_CASH_TITLE: "1Cash",
    KWIK_LINK_TITLE: "Compartir los productos",
    FIELD_PRODUCT: "Producto",
    FIELD_QUANTITY: "Cantidad",
    FIELD_PRICE: "Precio",
    FIELD_KWIKCASH: "KwikCash",
    SHARE_THIS_PRODUCT_TO: "Compartir",
    COPY_LINK: "Copiar enlace",
    RETURN_TO_HOME_BUTTON: "Volver a  Inicio",
    COPY_SUCCESS: "Enlace copiado correctamente",
    TOTAL_KWIKCASH_EARNED: "Total de KwikCash ganado",
    TOTAL_CASHED_OUT: "Total cobrado",
    KWIKCASH_BALANCE: "1Saldo en efectivo",
    CASH_OUT_BUTTON: "Retirar fondos",
    WEEK_COL_NAME: "Semana",
    KWIK_CASH_COL_NAME: "KwikCash",
    PRODUCT_INFO_TITLE: "Información del producto",
    KWIKCASH_VALUE: "Valor de KwikCash",
    "'DESCRIPTION': 'Description',": "Descripción",
    IMPORTANT_INFORMATION: "Información importante",
    "'INGREDIENTS': 'Ingredients',": "Ingredientes",
    "'USAGE': 'Usage',": "Uso",
    HANDLING_INSTRUCTIONS: "Instrucciones de manejo",
    "'MANUFACTURER': 'Manufacturer',": "Fabricante",
    ADD_TO_CART_BUTTON: "Añadir al carrito",
    YOUR_CART_TITLE: "Tu carrito",
    "'PRODUCTS': 'Products',": "Productos",
    REMOVE_LINK: "Eliminar",
    FIELD_TAX: "Impuestos",
    FIELD_TOTAL: "Total",
    PROCEED_TO_CHECKOUT_BUTTON: "Proceder al pago",
    CHECKOUT_TITLE: "Pago",
    SHIPPING_ADDRESS: "Dirección de envío",
    NEW_LINK: "Nuevo",
    PAYMENT_BREAKDOWN: "Desglose de pagos",
    SHOW_SAVE_CARDS: "Mostrar tarjetas guardadas",
    FIELD_NAME_ON_CARD: "Nombre de la tarjeta",
    FIELD_CARD_NUMBER: "Número de tarjeta",
    FIELD_EXPIRY_YEAR: "Año de vencimiento",
    FIELD_EXPIRY_MONTH: "Mes de vencimiento",
    FIELD_CVV: "CVV",
    SAVE_THIS_CARD: "Guardar esta tarjeta",
    BILLING_ADDRESS_IS_SAME_SHIPPING_ADDRESS:
      "Dirección de facturación es la misma que la dirección de envío",
    BILLING_ADDRESS: "Dirección de facturación",
    FIELD_FIRST_NAME: "Nombre",
    FIELD_LAST_NAME: "Apellido",
    FIELD_ADDRESS_LINE: "Dirección",
    FIELD_ZIP: "Código postal",
    FIELD_PHONE: "Número de teléfono",
    FIELD_CITY: "Ciudad",
    FIELD_STATE: "Comunidad autónoma",
    FIELD_COUNTRY: "País",
    FIELD_NAME: "Nombre",
    PLEASE_SELECT: "seleccionar",
    "'SHIPPING': 'Shipping',": "Envío",
    CONTINUE_TO_PLACE_ORDER_BUTTON: "Continuar para realizar el pedido",
    SAVE_AND_USE_THIS_ADDRESS_BUTTON: "Continuar a siguiente",
    "'CONGRATULATIONS': 'Order Complete!',": "¡Pedido completado!",
    PAYMENT_SUCCESSFUL: "Pago realizado",
    "'STANDARD': 'Standard',": "Estándar",
    ORDER_ACCEPTED: "Pedido aceptado",
    CHECKOUT_MESSAGE1:
      "Se ha realizado tu pedido n.º #{{orderId}} y se ha enviado un correo electrónico de confirmación a",
    CHECKOUT_MESSAGE2:
      "¡Enhorabuena! ¡Gana 2,5 $ cada vez que alguien compre con tu código promocional! Haz clic en el botón Compartir a continuación.",
    SHARE_THE_PRODUCT_BUTTON: "Kwik y gana",
    TRACK_ORDER: "Seguimiento del pedido",
    WAVES_COL: "Ondas",
    NAME_COL: "Nombre",
    ORDER_K_CASH_COL: "Total del pedido",
    K_CASH_RATE: "Tasa de K.Cash",
    CASH_HISTORY_TITLE: "Historial de efectivo",
    TRANSFER_TO_BANK_TITLE: "Transferir al banco",
    SAVED_BANK_LINK: "Banco guardado",
    ADD_BANK_LINK: "Añadir banco",
    SELECT_LINK: "Seleccionar",
    PROCEED_TO_NEXT_BUTTON: "Continuar a siguiente",
    FIELD_BANKS_COUNTRY: "País del banco",
    FIELD_CURRENCY_CODE: "Código de la moneda",
    FIELD_NAME_ON_ACCOUNT: "Nombre de la cuenta",
    FIELD_NAME_ON_ROUTING_NUMBER: "Número de ruta",
    FIELD_ACCOUNT_NUMBER: "Número de cuenta",
    FIELD_ACCOUNT_TYPE: "Tipo de cuenta",
    FIELD_ACCOUNT_TYPE_OPTION_CHECKING: "Cuenta corriente",
    FIELD_ACCOUNT_TYPE_OPTION_SAVINGS: "Cuenta de ahorro",
    FIELD_SWIFT_CODE_BIC: "Código Swift/BIC",
    FIELD_BANK_NAME: "Nombre del banco",
    FIELD_BANK_NUMBER: "Número de banco",
    FIELD_BRANCH_NAME: "Nombre de la sucursal",
    FIELD_BRANCH_CODE: "Código de la sucursal",
    SAFE_KEEP_MESSAGE:
      "Esta información se guardará de forma segura según las Condiciones de servicio y la Política de privacidad",
    SAVE_BANK_DETAILS_BUTTON: "Guardar datos bancarios",
    AVAILABLE_BALANCE: "Saldo disponible",
    TRANSFER_TO_INTRODUCE_MESSAGE:
      "Elige el importe de dinero que quieres transferir desde tu cuenta de KwikCash a la cuenta bancaria seleccionada.",
    FIELD_AMOUNT: "Importe",
    SELECTED_BANK: "Banco seleccionado",
    VERIFY_BANK_CARD_INFORMATION:
      "Comprueba que el banco y el importe de KwikCash son correctos. NO PUEDES cambiar de opinión después de hacer esto.",
    TRANSACTION_COMPLETE: "¡Operación completada!",
    TRANSACTION_CONSEQUENCE_MESSAGE:
      "Tu número de operación es  {{amount}} y se ha realizado. Se ha enviado un correo electrónico de confirmación a {{email}}",
    TRANSACTION_CONSEQUENCE_MESSAGE2:
      "Espera hasta 24 horas para que se actualice el saldo de KwikCash.",
    RETURN_BUTTON: "Volver a Inicio",
    VIEW_TRANSACTION_HISTORY: "Ver historial de operaciones",
    ORDER_TEXT: "Pedido",
    ITEM_LIST_IS_EMPTY: "Selecciona el producto",
    CART_MUST_NOT_BE_EMPTY: "El carrito de la compra no debe estar vacío",
    CLICK_SEND_EMAIL:
      "Haz clic en el botón para enviar un correo electrónico para confirmar la contraseña inicial",
    SELECTED_DATE_GREATER_CURRENT_DATE:
      "La fecha seleccionada debe ser posterior a la fecha actual",
    CARD_NUMBER_FORMAT_IS_INCORRECT:
      "El formato del número de tarjeta es incorrecto",
    ITEM_ADDED_TO_CART: "¡Has añadido correctamente el artículo al carrito!",
    ORDER_NUMBER: "Número de pedido",
    CREATION_TIME: "Fecha",
    ORDER_STATUS: "Estado del pedido",
    ARE_YOU_SURE: "¿Está seguro/a?",
    "'CANCEL': 'Cancel',": "Cancelar",
    "'OK': 'Ok',": "OK",
    EMAIL_IS_NOT_UNIQUE_SHARE_LINK:
      "Nuestros registros muestran que este correo electrónico ya tiene una cuenta en Kwik. Utiliza otro correo electrónico o inicia sesión para completar el pedido.",
    EMAIL_IS_NOT_UNIQUE:
      "Este correo electrónico ya se utiliza en kwik.com. Utiliza otro correo electrónico o ve a kwik.com para iniciar sesión y realizar pedidos de estos o más productos.",
    EMAIL_IS_NOT_UNIQUE_ARIIX:
      "Nuestros registros muestran que este correo electrónico ya ha sido registrado como cliente de ARIIX. Utiliza otro correo electrónico o ve a kwik.com  para iniciar sesión con este correo electrónico y explorar más campañas.",
    REQUIRED_FIELD: "Campo requerido",
    INCORRECT_EMAIL_FORMAT: "Formato de correo electrónico incorrecto",
    "'REFUND': 'Refund',": "Reembolso",
    "'DELETE': 'Delete',": "Borrar",
    PLEASE_INPUT_TAGLINK: "Introduce el enlace de la etiqueta",
    PLEASE_INPUT_CITY: "Introduce ciudad",
    UPDATE_SUCCESSFULLY: "Actualizar correctamente",
    TAGLINK_TEXT: "Etiqueta de enlace",
    EXPLORATION_TITLE: "Explorar",
    SEE_ALL_NUM_PRODUCTS: "Ver todos los {{prodNumber}} productos",
    LEARN_MORE_LINK: "Más información",
    KWIKCASH_VALUE_MESS: "Valor de KwikCash",
    SHARE_YOUR_LINK: "COMPARTE TU ENLACE",
    SEND_LINK_AND_EARN_KWIKCASH_MESS: "Enviar enlace y ganar KwikCash",
    PRICE_TEXT: "PRECIO",
    OUT_OF_STOCK_TEXT: "Agotado",
    ORDER_HISTORY_TEXT: "Historial de pedidos",
    ORDER_HISTORY_TIPS_NEED_PURCHASE: "¡Primero debes hacer una compra!",
    ORDER_HISTORY_EXPLORE_PRODUCTS: "Explorar productos",
    ORDER_HISTORY_ORDER_ON: "Pedido el",
    ORDER_DETAIL_EXPECTED_DATE: "Fecha prevista",
    ORDER_DETAIL_TRACKING_ID: "ID de seguimiento",
    ORDER_DETAIL_BILLING_INFO_SAME_AS_SHIPPING:
      "Información de facturación igual que la de envío",
    ORDER_DETAIL_ORIGINAL_PRICE: "Precio original",
    ORDER_DETAIL_SHIPPINGN_HANDING: "Envío y manipulación",
    KWIK_CASH_AVAILABLE_BALANCE: "Saldo disponible",
    KWIK_CASH_PENDING_BALANCE: "Saldo pendiente",
    KWIK_CASH_VIEW_HISTORY: "Ver historial",
    KWIK_CASH_TRANSFER_BANK: "Transferir al banco",
    ACCOUNT_NUMBER_4: "El número de cuenta no debe tener menos de 4 caracteres",
    KWIK_CASH_PENDING: "pendiente",
    KWIK_CASH_PAID: "pagado",
    KWIK_CASH_FULFILLED: "realizado",
    CAMPAIGNS_SHARE_A_CAMPAIGN: "Compartir una campaña",
    CAMPAIGNS_ACTIVE_CAMPAIGN: "Campaña activa",
    CAMPAIGNS_NODATA_TEXT: "Para empezar, busca un producto para promocionar",
    CAMPAIGNS_EXPLORE_PRODUCTS: "Explorar productos",
    PROGRESS_LOADING: "Cargando...",
    LOGIN_WELCOME_BACK: "¡Bienvenido/a de nuevo!",
    LOGIN_CREDENTIALS: "Introduce tus credenciales para continuar",
    LOGIN_LABEL_USERNAME: "Nombre de usuario",
    LOGIN_PLACEHOLDER_USERNAME: "Nombre de usuario o correo electrónico",
    LOGIN_REQUIRED_USERNAME: "Se requiere nombre de usuario",
    LOGIN__LABEL_PASSWORD: "Contraseña",
    LOGIN_PLACEHOLDER_PASSWORD: "Contraseña",
    LOGIN_REQUIRED_PASSWORD: "¡Introduce tu contraseña!",
    LOGIN_REMEMBER_ME: "Recuérdame",
    LOGIN_FORGOT_PASSWORD: "¿Has olvidado tu contraseña?",
    LOGIN_BUTTON_LOGIN: "Iniciar sesión",
    LOGIN_NEED_ACCOUNT: "¿Necesitas una cuenta?",
    LOGIN_CREATE_ACCOUNT: "Crear una nueva cuenta",
    VIEWS_REGISTER_1_CREATE_ACCOUNT: "Crea tu cuenta ",
    VIEWS_REGISTER_1_FIELDS_REQUIRED:
      "Rellena el siguiente formulario. Todos los campos son obligatorios.",
    VIEWS_REGISTER_1_LABEL_EMAIL_ADDRESS:
      "Dirección de correo electrónico (única)",
    VIEWS_REGISTER_1_PLACEHOLDER_EMAIL_ADDRESS:
      "Dirección de correo electrónico (única)",
    VIEWS_REGISTER_1_REQUIRED_EMAIL:
      "La dirección de correo electrónico no debe estar vacía",
    VIEWS_REGISTER_1_LABEL_FIRST_NAME: "Nombre",
    VIEWS_REGISTER_1_PLACEHOLDER_FIRST_NAME: "Nombre",
    VIEWS_REGISTER_1_REQUIRED_FIRST_NAME: "El nombre no debe estar vacío",
    VIEWS_REGISTER_1_LABEL_LAST_NAME: "Apellido",
    VIEWS_REGISTER_1_PLACEHOLDER_LAST_NAME: "Apellido",
    VIEWS_REGISTER_1_REQUIRED_LAST_NAME: "El apellido no debe estar vacío",
    VIEWS_REGISTER_1_LABEL_USER_NAME: "Nombre de usuario (único)",
    VIEWS_REGISTER_1_PLACEHOLDER_USER_NAME: "Nombre de usuario (único)",
    VIEWS_REGISTER_1_REQUIRED_USER_NAME:
      "El nombre de usuario no debe estar vacío",
    VIEWS_REGISTER_1_LABEL_PHONE: "Número de teléfono",
    VIEWS_REGISTER_1_PLACEHOLDER_PHONE: "Número de teléfono (único)",
    VIEWS_REGISTER_1_REQUIRED_PHONE:
      "El número de teléfono no debe estar vacío",
    VIEWS_REGISTER_1_BUTTON_NEXT: "Siguiente",
    VIEWS_REGISTER_1_TIPS_DIGIT_SENT:
      "Se ha enviado un código de 4 dígitos a tu correo electrónico",
    VIEWS_REGISTER_1_TIPS_EMAIL_REGISTERED:
      "Nuestros registros muestran que este correo electrónico ya ha sido registrado en Kwik",
    VIEWS_REGISTER_1_BUTTON_EMAIL_REGISTERED_FORGOT_PASSWORD:
      "He olvidado mi contraseña",
    VIEWS_REGISTER_1_BUTTON_EMAIL_REGISTERED_CANCEL: "Cancelar",
    VIEWS_REGISTER_1_TIPS_USERNAME_REGISTERED:
      "Nuestros registros muestran que este nombre de usuario ya ha sido registrado en Kwik.",
    VIEWS_REGISTER_1_BUTTON_OK: "Ok",
    VIEWS_REGISTER_2_VERIFICATION: "Verificación",
    VIEWS_REGISTER_2_TO_VERIFY: "Para verificar que eres tú",
    VIEWS_REGISTER_2_TIPS_ENTER:
      "Introduce el código de 4 dígitos que se te ha enviado a",
    VIEWS_REGISTER_2_BUTTON_NEXT: "Siguiente",
    VIEWS_REGISTER_2_NEED_CODE: "¿Aún no tienes un código?",
    VIEWS_REGISTER_2_LINK_RESEND: "Reenviar",
    VIEWS_REGISTER_2_LOADING: "Cargando...",
    VIEWS_REGISTER_3_TITLE_PASSWORD_CREATE: "Crear nueva contraseña",
    VIEWS_REGISTER_3_TITLE_ENTER_NEW_PASSWORD:
      "Introduce una nueva contraseña segura",
    VIEWS_REGISTER_3_CREATE_LABEL: "Crear contraseña",
    VIEWS_REGISTER_3_CREATE_PLACEHOLDER: "Crear contraseña",
    VIEWS_REGISTER_3_CREATE_REQUIRED: "¡Introduce tu contraseña!",
    VIEWS_REGISTER_3_CONFIRM_LABEL: "Confirmar contraseña",
    VIEWS_REGISTER_3_CONFIRM_PLACEHOLDER: "Confirmar contraseña",
    VIEWS_REGISTER_3_CONFIRM_REQUIRED: "¡Introduce tu contraseña!",
    VIEWS_REGISTER_3_TOAST_PATTERN:
      "La contraseña debe contener como mínimo ocho caracteres con al menos una mayúscula, una minúscula y un número en cifras.",
    VIEWS_REGISTER_3_TIPS_MATCH: "Las dos contraseñas no coinciden",
    VIEWS_REGISTER_3_BUTTON_NEXT: "Siguiente",
    VIEWS_REGISTER_3_BUTTON_BACK: "Volver",
    VIEWS_REGISTER_3_LOADING: "Cargando...",
    VIEWS_REGISTER_4_TITLE: "Sube una foto de perfil",
    VIEWS_REGISTER_4_MESSAGE:
      "Esto te dará a conocer y generará confianza en tu cuenta",
    VIEWS_REGISTER_4_BUTTON_NEXT: "Continuar a siguiente",
    VIEWS_REGISTER_4_TIPS_NOT_NOW: "¿Ahora no?",
    VIEWS_REGISTER_4_LINK_DO_LATER: "Quiero hacerlo más tarde",
    VIEWS_REGISTER_5_TITLE: "Crea tu cuenta ",
    VIEWS_REGISTER_5_MESSAGE: "Facilita la siguiente información",
    VIEWS_REGISTER_5_TIPS_YOUR_BIO: "Tu bio",
    VIEWS_REGISTER_5_PLACEHOLDER_TYPING: "Empieza a escribir aquí...",
    VIEWS_REGISTER_5_BUTTON_NEXT: "Enviar y continuar a siguiente",
    VIEWS_REGISTER_5_TIPS_NOT_NOW: "¿Ahora no?",
    VIEWS_REGISTER_5_LINK_DO_LATER: "Quiero hacerlo más tarde",
    VIEWS_REGISTER_6_BUTTON_BACK: "Volver",
    VIEWS_REGISTER_6_TITLE: "Proporciona tus datos personales",
    VIEWS_REGISTER_6_MESSAGE: "Proporciona algunos de tus datos",
    VIEWS_REGISTER_6_ADDRESS_LINE_1: "Dirección línea 1",
    VIEWS_REGISTER_6_ADDRESS_LINE_2: "Dirección línea 2",
    VIEWS_REGISTER_6_POSTAL_CODE: "Código postal",
    VIEWS_REGISTER_6_BUTTON_NEXT: "Siguiente",
    VIEWS_REGISTER_6_COUNTRY_USA: "Estados Unidos",
    VIEWS_REGISTER_6_COUNTRY_CHA: "China",
    VIEWS_REGISTER_SSO_1_TIPS_EMAIL_REGISTERED:
      "Nuestros registros muestran que este nombre de usuario ya se ha registrado con Kwikclick. ",
    VIEWS_REGISTER_SSO_1_BUTTON_OK: "Ok",
    VIEWS_REGISTER_SSO_1_TIPS_SIGNUP: "Inscribirse",
    VIEWS_REGISTER_SSO_1_TITLE: "Crea tu cuenta ",
    VIEWS_REGISTER_SSO_1_MESSAGE:
      "¡Enhorabuena! Se han verificado tu ID y contraseña de NewAge. Facilita la siguiente información",
    VIEWS_REGISTER_SSO_1_TIPS_EMAIL:
      "Correo electrónico (Verificaremos que tu correo electrónico es único)",
    VIEWS_REGISTER_SSO_1_TIPS_FIRST: "Nombre",
    VIEWS_REGISTER_SSO_1_REQUIRED_FIRST: "El nombre no debe estar vacío",
    VIEWS_REGISTER_SSO_1_TIPS_LAST: "Apellido",
    VIEWS_REGISTER_SSO_1_REQUIRED_LAST: "El apellido no debe estar vacío",
    VIEWS_REGISTER_SSO_1_TIPS_USERNAME:
      "Nombre de usuario (Verificaremos que tu nombre de usuario es único)",
    VIEWS_REGISTER_SSO_1_REQUIRED_USERNAME:
      "El nombre de usuario no debe estar vacío",
    VIEWS_REGISTER_SSO_1_TIPS_PHONE: "Número de teléfono",
    VIEWS_REGISTER_SSO_1_REQUIRED_PHONE:
      "El número de teléfono no debe estar vacío",
    VIEWS_REGISTER_SSO_1_BUTTON_NEXT: "Siguiente",
    CAMPAIGNS_BUTTON_OK: "Ok",
    CAMPAIGNS_LOADING: "Cargando...",
    CAMPAIGNS_CANNOT_SHARE_MESSAGE_1:
      "Lo sentimos, no puedes compartir el producto",
    CAMPAIGNS_CANNOT_SHARE_MESSAGE_2:
      "Compra este producto ahora o solicita la elegibilidad",
    CAMPAIGNS_TITLE_STATS: "Estadísticas",
    CAMPAIGNS_TIPS_CASH_EARNED: "Total de KwikCashganado esta semana",
    CAMPAIGNS_TIPS_TOTAL_KWIKCASH_EARNED: "Total de KwikCash ganado",
    CAMPAIGNS_TIPS_GENERATE_SALES: "Ventas generadas",
    CAMPAIGNS_TITLE_CAMPAIGNS: "Campañas",
    CAMPAIGNS_TIPS_VIEW_DETAIL: "(Haz clic para ver los detalles)",
    CAMPAIGNS_TITLE_ALL_STATS: "Estadísticas de todas las campañas",
    CAMPAIGNS_TIPS_KWIK_INFO: "Información de Kwik",
    CAMPAIGNS_TITLE_TOTAL_BUYERS: "Total de compradores",
    CAMPAIGNS_BUTTON_QR_CODE: "Código QR",
    CAMPAIGNS_BUTTON_COPY_LINK: "Copiar enlace",
    CAMPAIGNS_HEADER_TITLE_CAMPAIGNS_STATS: "Estadísticas de campañas",
    CAMPAIGNS_TITLE_TOTAL_CUSTOMERS: "Total de clientes",
    CAMPAIGNS_BUTTON_VIEW_DATA: "Ver datos",
    CAMPAIGNS_TITLE_ACTIVE_CAMPAIGN: "Campaña activa",
    CAMPAIGNS_TITLE_SHARE_CAMPAIGN: "Compartir una campaña",
    CAMPAIGNS_TITLE_CAMPAIGN_DETAILS: "Detalles de la campaña",
    CAMPAIGNS_TITLE_WAVES: "Ondas",
    CAMPAIGNS_TIPS_KWIKCASH_EARNED: "1Cash ganado",
    CAMPAIGNS_TITLE_BUYER: "Comprador",
    CAMPAIGNS_COLOR_MEANS_GREEN: "Verde significa que KwikCash está disponible",
    CAMPAIGNS_COLOR_MEANS_YELLOW:
      "Amarillo significa que KwikCash está pendiente",
    CAMPAIGNS_COLOR_MEANS_RED:
      "Rojo significa que KwikCash no se puede entregar",
    CAMPAIGNS_TITLE_KWIK_INFO: "Información de Kwik",
    SHARE_LINK_IMAGE_5M: "Las imágenes no deben superar los 5 megabytes",
    SHARE_LINK_REFERRED_BY: "Referido por",
    SHARE_LINK_DESCRIPTION: "Descripción",
    SHARE_LINK_ADD_TO_CART: "Añadir al carrito",
    SHARE_LINK_PRODUCTS_DESC: "Descripción del producto",
    SHARE_LINK_LEAVE_MESSAGE: "Dejar una reseña",
    SHARE_LINK_LEARN_MORE: "Más información",
    SHARE_LINK_REVIEWS: "Reseñas",
    SHARE_LINK_RATE_THE_PRODUCT: "Valora el producto",
    SHARE_LINK_SHARE_YOUR_THOUGHTS_ON_THE_PRODUCT:
      "Comparte tus opiniones sobre el producto",
    SHARE_LINK_ADD_AN_IMAGE_TO_YOUR_REVIEW: "Añade una imagen a tu reseña",
    SHARE_LINK_DRAG_AND_DROP: "ARRASTRAR Y SOLTAR",
    SHARE_LINK_YOUR_FILES_TO_ASSETS_OR_BROWSE:
      "tus archivos a los recursos, o <span>navegar</span>",
    SHARE_LINK_LEAVE_REVIEW: "Dejar una reseña",
    SHARE_LINK_MY_CART: "Mi carrito",
    SHARE_LINK_CHECKOUT: "PAGO",
    SHARE_LINK_CHECKOUT2: "Pago",
    SHARE_LINK_DISCOUNT: "Descuento",
    SHARE_LINK_WILL_BE_CALCULATED_AT_CHECKOUT:
      "Se calculará en el momento de la compra",
    SHARE_LINK_RETURNING_CUSTOMER: "Ya soy cliente",
    SHARE_LINK_SIGN_IN_FOR_FASTER_CHECKOUT:
      "Iniciar sesión para completar la compra más rápido",
    SHARE_LINK_USERNAME_OR_EMAIL: "Nombre de usuario o correo electrónico",
    SHARE_LINK_USERNAME_IS_REQUIRED: "Se requiere nombre de usuario",
    SHARE_LINK_PASSWORD: "Contraseña",
    SHARE_LINK_OR: "O",
    SHARE_LINK_NEW_CUSTOMER: "Cliente nuevo",
    SHARE_LINK_DONT_HAVE_A_MESSAGE:
      "¿Todavía no tienes una cuenta Kwik? ¡Este es el primer paso! ¡Finaliza la operación para empezar a configurar tu cuenta!",
    SHARE_LINK_ADD_NEW_ADDRESS: "Añadir nueva dirección",
    SHARE_LINK_TO_MAKE_SURE_MESSAGE:
      "Para garantizar que la conexión funciona correctamente, asegúrate de que este es el correo electrónico que has utilizado o utilizarás en tu cuenta Kwik",
    SHARE_LINK_ADDRESS: "Dirección",
    SHARE_LINK_APARTMENT_SUITE_ETC: "Apartamento, suite, etc. (opcional)",
    SHARE_LINK_APT_SUITE_ETC: "Apto., suite, etc. (opcional)",
    SHARE_LINK_CITY: "Ciudad",
    SHARE_LINK_COUNTRY: "País",
    SHARE_LINK_STATE: "Comunidad autónoma",
    SHARE_LINK_ZIP_CODE: "Código postal",
    SHARE_LINK_PHONE: "Teléfono",
    SHARE_LINK_CANCEL: "Cancelar",
    SHARE_LINK_PRODUCTS: "Productos",
    SHARE_LINK_SHIPPING: "Envío",
    SHARE_LINK_TOTAL: "Total",
    SHARE_LINK_ENTER_YOUR_CARD_DETAILS: "Introduce los datos de tu tarjeta",
    SHARE_LINK_PLEASE_INPUT_YOUR_CARD_NAME:
      "¡Introduce el nombre de tu tarjeta!",
    SHARE_LINK_PLEASE_INPUT_YOUR_CARD_NUMBER:
      "¡Introduce el número de tu tarjeta!",
    SHARE_LINK_EXPIRATION_DATE: "Fecha de vencimiento",
    SHARE_LINK_EXPIRATION_YEAR: "Año de vencimiento",
    SHARE_LINK_PLEASE_INPUT_YOUR_CARD_CVV: "¡Introduce el CVV de tu tarjeta!",
    SHARE_LINK_BILLING_ADDRESS_IS_THE_SAME_MESSAGE:
      "La dirección de facturación es la misma que la dirección de entrega",
    SHARE_LINK_ENTER_YOUR_BILLING_ADDRESS:
      "Introduce tu dirección de facturación",
    SHARE_LINK_SAVE_THIS_CARD: "Guardar esta tarjeta",
    SHARE_LINK_COUNTINUE: "Continuar",
    SHARE_LINK_SHIPPING_ADDRESS: "Dirección de envío",
    SHARE_LINK_EDIT: "Editar",
    SHARE_LINK_SHIPPING_AND_HANDLING: "Envío y manipulación",
    SHARE_LINK_CHANGE: "Cambio",
    SHARE_LINK_PRICE_COUNT_ITEM: "Precio ({{count}} artículo)",
    SHARE_LINK_PRICE_TAX: "Impuestos",
    SHARE_LINK_PRICE: "PRECIO",
    SHARE_LINK_PLACE_YOUR_ORDER: "Haz tu pedido",
    SHARE_LINK_PAYMENT_SUCCESSFUL: "Pago realizado",
    SHARE_LINK_CONGRATS_MESSAGE:
      "¡Enhorabuena! ¡Gana KwikCash cada vez que alguien compra con tu código promocional! Haz clic en el botón Compartir a continuación.",
    SHARE_LINK_SHARE_YOUR_LINK: "COMPARTE TU ENLACE",
    SHARE_LINK_CREATE_MY_ACCOUNT: "Crear mi cuenta",
    SHARE_LINK_DOWNLOAD_IMAGE: "Descargar imagen",
    SHARE_LINK_COPY_LINK: "Copiar enlace",
    SHARE_LINK_ORDER_ACCEPTED: "Pedido aceptado",
    SHARE_LINK_SELECT_THE_PRODUCTS_YOU_WOULD_LIKE:
      " Selecciona los productos que deseas",
    SHARE_LINK_PRODUCT_NOT_AVAILABLE:
      "    El producto que has elegido no está disponible en el país seleccionado",
    SHARE_LINK_OUT_OF_STOCK: "Agotado",
    SHARE_LINK_PRICE2: "Precio",
    SHARE_LINK_ADD: "Añadir",
    SHARE_LINK_CONTINUE_TO_CHECKOUT: "Continuar con el pago",
    SHARE_LINK_SO_YOURE_ALREADY_MESSAGE:
      "Así que ya estás en  {{totalAlreadyJoin}} de las  {{totalCpgn}} campañas que has seleccionado. Cuando completes la compra de los productos te unirás  {{referName}} a las  {{totalCanJoin}} campañas seleccionadas",
    SHARE_LINK_SINCE_YOU_ALREADY_MESSAGE:
      "Como ya te has unido a esta campaña {{originalName}}, obtendrán el crédito",
    SHARE_LINK_SINCE_YOU_HAVE_ALREADY_MESSAGE:
      "Dado que ya te has unido a todas las  {{totalAlreadyJoin}} campañas. Cuando completes la compra de los productos, obtendrán el crédito.",
    SHARE_LINK_CLICK_TO_SEE_DETAILS: "Haz clic para ver los detalles",
    SHARE_LINK_REFERRER: "Recomendante",
    SHARE_LINK_CAMPAIGN: "Campaña",
    SHARE_LINK_CAMPAIGNS_TYPE: "Tipo de campaña",
    SHARE_LINK_DATE_JOINED: "Fecha de entrada",
    SHARE_LINK_SINGLE_CAMPAIGN: "Campaña única",
    SHARE_LINK_ULTI_PRODUCT: "ulti - Producto",
    SHARE_LINK_KWIKCASH: "1Cash",
    SHARE_LINK_QUANTITY: "Cantidad",
    SHARE_LINK_SUBTOTAL: "Subtotal",
    SHARE_LINK_PLEASE_INPUT_YOUR_FIRSTNAME: "¡Introduce tu nombre!",
    SHARE_LINK_PLEASE_INPUT_YOUR_LASTNAME: "¡Introduce tu apellido!",
    SHARE_LINK_PLEASE_INPUT_YOUR_ZIP: "¡Introduce tu código postal!",
    SHARE_LINK_PLEASE_INPUT_YOUR_STATE: "¡Introduce tu comunidad autónoma!",
    SHARE_LINK_PLEASE_INPUT_YOUR_CITY: "¡Introduce tu ciudad!",
    SHARE_LINK_PLEASE_INPUT_YOUR_ADDRESS_LINE1:
      "¡Introduce la línea 1 de tu dirección!",
    SHARE_LINK_PLEASE_SELECT_YOUR_STATE: "¡Selecciona tu comunidad autónoma!",
    SHARE_LINK_PLEASE_INPUT_YOUR_ADDRESS_PHONE: "¡Introduce tu teléfono!",
    SHARE_LINK_EXISTING_KWIK_USER_LOGIN_HERE:
      "¿Ya eres usuario de Kwik? Iniciar sesión aquí",
    SHARE_LINK_STEP_ADDRESS: "Dirección",
    SHARE_LINK_STEP_PAYMENTS: "Pagos",
    SHARE_LINK_STEP_SUMMARY: "Resumen",
    SHARE_LINK_BUTTON_LOGIN: "Iniciar sesión",
    SHARE_LINK_BUTTON_CONTINUE: "Continuar",
    SHOPPING_NEW_AGE_PV: "PV de NewAge",
    SHOPPING_PRODUCT_DESCRIPTION: "Descripción del producto",
    SHOPPING_REVIEWS: "Reseñas",
    SHOPPING_LEAVE_REVIEW: "Dejar una reseña",
    SHOPPING_RATE_PRODUCT: "Valora el producto",
    SHOPPING_SHARE_THOUGHTS_PRODUCT: "Comparte tus opiniones sobre el producto",
    SHOPPING_PLACEHOLDER_TYPING: "Empezar a escribir",
    SHOPPING_PLEASE_TYPING: "Introduce texto en empezar a escribir",
    SHOPPING_TIPS_ADD_IMAGE: "Añade una imagen a tu reseña",
    SHOPPING_BUTTON_REMOVE: "Eliminar",
    SHOPPING_TIPS_IMAGE_UPLOAD_1: "tus archivos a recursos o",
    SHOPPING_TIPS_IMAGE_UPLOAD_2: "navegar",
    SHOPPING_BUTTON_LEAVE_REVIEW: "Dejar una reseña",
    SHOPPING_BUTTON_DRAG_DROP: "ARRASTRAR Y SOLTAR",
    SHOPPING_BUTTON_CHECKOUT: "Pago",
    SHOPPING_SHARE_LINK_TEXT_PRICE: "PRECIO",
    SHOPPING_SHARE_LINK_TEXT_NEW_AGE_PV: "PV de NewAge",
    SHOPPING_BUTTON_QR_CODE: "Código QR",
    SHOPPING_BUTTON_COPY_LINK: "Copiar enlace",
    SHOPPING_BUTTON_QUICK_SHARE: "Quick share",
    SHOPPING_BUTTON_DOWNLOAD_IMAGE: "descargar imagen",
    SHOPPING_BUTTON_X: "X",
    SHOPPING_BUTTON_CANCEL: "Cancelar",
    SHOPPING_CART_TEXT_PRICE: "Precio",
    SHOPPING_CART_TEXT_KWIKASH: "KwikCash",
    SHOPPING_CART_TEXT_SHIP_FROM: "Enviar desde",
    SHOPPING_CART_TEXT_SUBTOTAL: "Subtotal",
    SHOPPING_BUTTON_CHANGE: "Cambio",
    SHOPPING_TITLE_COUPON: "Cupón",
    SHOPPING_OPTION_SELECT_COUPON: "Selecciona un cupón disponible para ti",
    SHOPPING_REQUIRED_INPUT_CARD_NAME: "¡Introduce el nombre de tu tarjeta!",
    SHOPPING_REQUIRED_INPUT_CARD_NUMBER: "¡Introduce el número de tu tarjeta!",
    SHOPPING_TEXT_EXPIRATION_DATE: "Fecha de vencimiento",
    SHOPPING_TEXT_EXPIRATION_YEAR: "Año de vencimiento",
    SHOPPING_REQUIRED_INPUT_CARD_CVV: "¡Introduce el CVV de tu tarjeta!",
    SHOPPING_REQUIRED_INPUT_FIRST_NAME: "¡Introduce tu nombre!",
    SHOPPING_REQUIRED_INPUT_LAST_NAME: "¡Introduce tu apellido!",
    SHOPPING_REQUIRED_INPUT_ADDRESS_1: "¡Introduce la línea 1 de tu dirección!",
    SHOPPING_REQUIRED_INPUT_STATE: "¡Selecciona tu comunidad autónoma!",
    SHOPPING_REQUIRED_INPUT_CITY: "¡Introduce tu ciudad!",
    SHOPPING_REQUIRED_INPUT_ZIP: "¡Introduce tu código postal!",
    SHOPPING_REQUIRED_INPUT_PHONE: "¡Introduce tu teléfono!",
    SHOPPING_TEXT_SHIPPING_HANDING: "Envío y manipulación",
    SHOPPING_TEXT_SHOW_SAVED_CARD: "Mostrar tarjetas guardadas",
    SHOPPING_SUCCESS_TEXT_CONGRATS:
      "¡Enhorabuena! ¡Gana KwikCash cada vez que alguien compra con tu código promocional! Haz clic en el botón Compartir a continuación.",
    SHOPPING_PAYMENT_TEXT_PAYMENT_SUCCESSFUL: "Pago realizado",
    SHOPPING_PAYMENT_TEXT_SHARE_LINK: "COMPARTE TU ENLACE",
    SHOPPING_PAYMENT_TEXT_ORDER_ACCEPTED: "Pedido aceptado",
    SHOPPING_PASSWORD_TITLE_FORGOT: "Has olvidado tu contraseña",
    SHOPPING_PASSWORD_TEXT_VERIFY: "Para verificar que eres tú",
    SHOPPING_PASSWORD_TEXT_ENTER_EMAIL:
      "Introduce tu correo electrónico registrado a continuación para recibir el enlace con las instrucciones de restablecimiento de la contraseña",
    SHOPPING_PASSWORD_LABEL_EMAIL: "Dirección de correo electrónico",
    SHOPPING_PASSWORD_PLACEHOLDER_EMAIL: "Dirección de correo electrónico",
    SHOPPING_PASSWORD_REQUIRED_EMAIL: "Correo electrónico obligatorio",
    SHOPPING_PASSWORD_BUTTON_RESET: "Restablecer la contraseña",
    SHOPPING_PASSWORD_SEND_EMAIL: "¡Se ha enviado un correo electrónico!",
    SHOPPING_PASSWORD_SEND_CHECK_INBOX:
      "Revisa tu bandeja de entrada y haz clic en el enlace para\n restablecer tu contraseña.",
    SHOPPING_PASSWORD_SEND_BACK_TO_LOGIN: "Volver al inicio de sesión",
    SHOPPING_PASSWORD_SEND_TEXT_DONT_RECEIVE: "¿No has recibido el enlace?",
    SHOPPING_PASSWORD_SEND_BUTTON_RESEND: "Reenviar",
    SHOPPING_PASSWORD_SEND_BUTTON_BACK: "Volver",
    HEADER_PHOTO_EDIT_IMAGE: "Editar imagen",
    HEADER_PHOTO_OK: "OK",
    HEADER_PHOTO_CANCEL: "Cancelar",
    HEADER_HOME: "Inicio",
    HEADER_1CASH: "1Cash",
    HEADER_CAMPAIGNS: "Campañas",
    HEADER_REWARDS: "Recompensas",
    HEADER_ORDER_HISTORY: "Historial de pedidos",
    HEADER_SIGN_OUT: "Cerrar sesión",
    HEADER_LOGOUT: "Cerrar sesión",
    LOGIN_HEADER_TITLE_REPORT_ISSUE: "Informar de un problema",
    LOGIN_HEADER_LABEL_SUBJECT: "Asunto",
    LOGIN_HEADER_PLACEHOLDER_SUBJECT: "Resume tu problema aquí",
    LOGIN_HEADER_LABEL_DESCRIPTION: "Descripción",
    LOGIN_HEADER_PLACEHOLDER_DESCRIPTION:
      "Explica el problema en detalle aquí...",
    WELINK_ADDRESS_WE_RE_CURRENTLY:
      "We’re Currently Focused On expanding in the following Metro areas:  Las Vegas, NV; Pheonix, AZ, TUSCON, AZ. WE’LL BE BRINGING OUR WIRELESS FIBER TO EVEN MORE MARKETS IN 2022",
    WELINK_ADDRESS_FIRST_NAME: "Nombre",
    WELINK_ADDRESS_LAST_NAME: "Apellido",
    WELINK_ADDRESS_COMPANY_NAME: "Nombre de empresa",
    WELINK_ADDRESS_EMAIL: "Correo electrónico",
    WELINK_ADDRESS_ADDRESS: "Dirección",
    WELINK_ADDRESS_APT_SUITE_ETC_OPTIONAL: "Apto., suite, etc. (opcional)",
    WELINK_ADDRESS_CITY: "Ciudad",
    WELINK_ADDRESS_COUNTRY: "País",
    WELINK_ADDRESS_STATE: "Comunidad autónoma",
    WELINK_ADDRESS_ZIP_CODE: "Código postal",
    WELINK_ADDRESS_PHONE: "Teléfono",
    WELINK_ADDRESS_HOW_MANY_W2_EMPLOYEES_DO_YOU_HAVE:
      "How many w2 Employees do you have?",
    WELINK_ADDRESS_HAS_YOUR_BUSINESS_BEEN:
      "Has your business been impacted or changed by COVID?",
    WELINK_ADDRESS_HAS_YOUR_BUSINESS_HAD:
      'Has your business had a supply chain "disruption" to your business?',
    WELINK_ADDRESS_PROCEED_TO_NEXT: "Continuar a siguiente",
    FIELD_PROVINCE: "Provincia",
    FIELD_TOWN_CITY: "Población/Ciudad",
    FIELD_POSTAL_CODE: "Código postal",
    SSONEWAGE_IF_YOU_ALREADY_SET_UP_MESSAGE:
      'Si ya has configurado tu cuenta de Kwik en "Registrarse con NewAge", también puedes iniciar sesión en la App de Kwik con tu correo electrónico y contraseña de Kwik <a href="/">haciendo clic</a> aquí',
    SSONEWAGE_SIGN_IN_WITH_NEWAGE: "Registrarse con NewAge",
    SSONEWAGE_LINK_AN_EXISTING_ACCOUNT_WITH_NEWAGE_ACCOUNT:
      "Vincular una cuenta existente con una cuenta de NewAge",
    SSONEWAGE_WELCOME_BACK: "¡Bienvenido/a de nuevo!",
    SSONEWAGE_ENTER_YOUR_CREDENTIALS_TO_CONTINUE:
      "Introduce tus credenciales para continuar",
    SSONEWAGE_EMAIL: "Correo electrónico",
    SSONEWAGE_USERNAME: "Nombre de usuario",
    SSONEWAGE_USERNAME_IS_REQUIRED: "Se requiere nombre de usuario",
    SSONEWAGE_PASSWORD: "Contraseña",
    SSONEWAGE_NEXT: "Siguiente",
    SSONEWAGE_PLEASE_VERIFY_KWIK_ACCOUNT_INFOMATION:
      "Comprueba la información de la cuenta de Kwik",
    SSONEWAGE_KWIK_ACCOUNT_EMAIL: "Correo electrónico de la cuenta de Kwik",
    SSONEWAGE_FIRST_NAME: "Nombre",
    SSONEWAGE_LAST_NAME: "Apellido",
    SSONEWAGE_PHONE_NUMBER: "Número de teléfono",
    SSONEWAGE_NEWAGE_ID: "ID de NewAge",
    SSONEWAGE_YOUR_KWIK_ACCOUNT_HAS_ALREADY_MESSAGE:
      "Tu cuenta de Kwik ya se ha vinculado a este ID de NewAge. Si este es tu ID de NewAge correcto, no es necesario hacer más acciones.",
    SSONEWAGE_IF_THIS_IS_NOT_MESSAGE:
      "Si este no es tu ID de NewAge correcto, puedes actualizarlo.",
    SSONEWAGE_UPDATE: "Actualizar",
    SSONEWAGE_IS_THIS_YOU: "¿Eres tú esta persona?",
    SSONEWAGE_YES_AND_PROCEED_TO_NEXT_STEP:
      "Sí y continuar con el paso siguiente",
    SSONEWAGE_OUR_RECORDS_SHOW_THAT_THIS_MESSAGE:
      "Nuestros registros muestran que este ID de NewAge {{newAgeID}} ha sido vinculado a otra cuenta de Kwik. Comprueba tu ID de NewAge e inténtalo más tarde. ¡Gracias!",
    SSONEWAGE_OK: "OK",
    SSONEWAGE_CONDRATULATIONS_YOUR_NEWAGE_ID_MESSAGE:
      "¡Felicidades! Se han verificado tu ID y contraseña de NewAge. ¿Te gustaría vincular este ID de NewAge con tu cuenta de Kwik?",
    SSONEWAGE_YES: "Sí",
    SSONEWAGE_NO: "No",
    SSONEWAGE_OUR_RECORDS_SHOW_THAT_MESSAGE:
      "Nuestros registros muestran que este nombre de usuario ya ha sido registrado en Kwik.",
    SSONEWAGE_OUR_RECORDS_SHOW_THAT_THIS_EMAIL_MESSAGE:
      "Nuestros registros muestran que este correo electrónico ya ha sido registrado en Kwik.",
    SSONEWAGE_FORGOT_PASSWORD: "He olvidado mi contraseña",
    FIELD_DUTY: "Deber",
    SHARE_LINK_BTGIN_QUALIFYING: "Empezar con la cualificación",
    "'KWIKCASH': 'KwikCash',": "KwikCash",
    "'CONNECTED': 'Connected!',": "¡Conectado!",
    ADD_BANK_ACCOUNT: "Añadir cuenta bancaria",
    CONNECTED_YOUR_ACCOUNT: "Hemos conectado tu cuenta con",
    KWIKCASH_SUCCESSFULLY_ADDED_1: "¡Has añadido esto correctamente",
    KWIKCASH_SUCCESSFULLY_ADDED_2:
      "a tu cuenta! Ahora, necesitamos confirmar que eres el titular de esta cuenta bancaria. Así es como lo hacemos",
    KWIKCASH_PROCESSING_STEP_1:
      "Durante los próximos 1 a 3 días hábiles, haremos dos pequeños ingresos en tu cuenta. Los importes no superarán 1 $USD.",
    KWIKCASH_PROCESSING_STEP_2:
      "Cuando hayas visto estos ingresos en tu cuenta bancaria, introduce esos importes en la siguiente página",
    KWIKCASH_PROCESSING_STEP_3: "¡Empieza a cobrar!",
    "'COMPLETE': 'Complete',": "Completar",
    ENTER_AMOUNT: "Introduce el importe",
    TRANSFER_AMOUNT_DESC:
      "Elige el importe de dinero que quieres transferir desde tu cuenta de KwikCash a tu cuenta bancaria seleccionada.",
    KWIKCASH_SELECT_BANK_ACCOUNT: "Seleccionar cuenta bancaria",
    KWIKCASH_AMOUNT_TO_TRANSFER: "Importe a transferir",
    KWIKCASH_ADD_ACCOUNT: "Añadir cuenta",
    KWIKCASH_PLEASE_CONFIRM: "Confirmar",
    KWIKCASH_TRANSFER_AMOUNT: "Importe de transferencia de KwikCash",
    KWIKCASH_TO: "a",
    KWIKCASH_PROCESSING_FEE: "Tasa de tramitación:",
    KWIKCASH_NET_CASHOUT: "Retirada de efectivo neto:",
    KWIKCASH_TRANSFER: "Transferir",
    KWIKCASH_CONFIRM: "Confirmar",
    KWIKCASH_CANCEL: "Cancelar",
    KWIKCASH_AMOUNT: "Importe",
    KWIKCASH_BANK_NAME: "Nombre del banco",
    KWIKCASH_NEXT: "Siguiente",
    KWIKCASH_TRANSFER_SUCCESS_1: "Tu número de operación es",
    KWIKCASH_TRANSFER_SUCCESS_2:
      "y ha sido realizada. Se ha enviado un correo electrónico de confirmación a",
    KWIKCASH_TRANSFER_SUCCESS_3:
      "Espera hasta 24 horas para que se actualice el saldo de KwikCash",
    KWIKCASH_BACK_KWIKCASH: "Volver a 1Cash",
    KWIKCASH_SUCCESS_HEADER: "¡Hecho!",
    KWIKCASH_PHONE_HEADER: "Verificación del teléfono",
    KWIKCASH_PHONE_1: "Verifica que eres tú",
    KWIKCASH_PHONE_2: "Introduce el código de 4 dígitos que se te ha enviado a",
    KWIKCASH_DIDNT_GET_CODE: "¿No has recibido el código?",
    KWIKCASH_RESEND_IT: "Reenviar",
    KWIKCASH_THE_BANK_NAME: "La cuenta bancaria",
    KWIKCASH_BANK_LINKED: "Ha sido vinculada a tu cuenta",
    KWIKCASH_ENTER_DEPOSIT_DESC:
      "Introduce dos importes que ingresamos en tu cuenta",
    KWIKCASH_DEPOSIT_1: "Importe del ingreso 1",
    KWIKCASH_DEPOSIT_2: "Importe del ingreso 2",
    KWIKCASH_DEPOSIT_DESC:
      "Puede que los ingresos tarden en aparecer en tu cuenta. Espera de 1 a 3 días para verlos.",
    KWIKCASH_VERIFY: "Verificar",
    KWIKCASH_BACK: "Volver",
    KWIKCASH_BANK_VERIFY: "Verificar cuenta bancaria",
    KWIKCASH_HISTORY: "Historial de KwikCash",
    KWIKCASH_NO_TRANSACTIONS: "No hay operaciones recientes",
    KWIKCASH_CONNECT: "Conectar",
    KWIKCASH_BANK_ACCOUNTS: "Cuentas bancarias",
    KWIKCASH_PENDING: "pendiente",
    KWIKCASH_CONNECT_TO: "Conectar a",
    KWIKCASH_FEATURE_TBA:
      "Lo sentimos, esta función aún está en construcción. Vuelve a una fecha posterior",
    KWIKCASH_LINKED_ACCOUNTS: "Cuentas vinculadas",
    KWIKCASH_VALIDATION_MESSAGE:
      "Rellena el siguiente formulario. Todos los campos son obligatorios.",
    VENDOR_ALL_VENDORS: "Todos los vendedores",
    VENDOR_CAMPAIGNS: "Campañas",
    VENDOR_CAMPAIGN_LOGO: "Logotipo de la campaña",
    VENDOR_CAMPAIGN_NAME: "Nombre de campaña",
    VENDOR_MARKET: "Mercado",
    VENDOR_CURRENCY: "Divisa",
    VENDOR_START_DATE: "Fecha de inicio",
    VENDOR_END_DATE: "Fecha fin",
    VENDOR_ACTIONS: "Acciones",
    VENDOR_EDIT: "Editar",
    VENDOR_DELETE: "Borrar",
    VENDOR_BACK_TO_CAMP_LIST: "Volver al Listado de Campañas",
    VENDOR_CAMP_DETAIL: "Detalle de la campaña",
    VENDOR_UPDATE: "Actualizar",
    VENDOR_SAVE: "Guardar",
    VENDOR_CANCEL: "Cancelar",
    VENDOR_PLS_INPUT_CAMP_NAME: "¡Introduce el nombre de la campaña!",
    VENDOR_PLS_SELECT_ONE: "¡Selecciona uno!",
    VENDOR_PRTS: "Compra obligatoria para compartir",
    VENDOR_NPRTS: "    No es necesario realizar ninguna compra para compartir",
    VENDOR_FREE_TO_SHARE: "Gratis para compartir",
    VENDOR_CAMP_IMAGE: "Imagen de campaña",
    VENDOR_DRAG_AND_DROP: "ARRASTRAR Y SOLTAR",
    VENDOR_YFTA: "tus archivos a recursos, o",
    VENDOR_BROWSE: "navegar",
    VENDOR_IMAGE: "Imagen",
    VENDOR_PRODUCT_NAME: "Nombre del producto",
    VENDOR_AC_NAME: "Acciones/nombre de la campaña",
    VENDOR_TPHBATTC: "Este producto ha sido asignado a la campaña",
    VENDOR_AYSYWT_DELETE: "¿Seguro que quieres borrarlo?",
    VENDOR_YCLTC_TIPS:
      "No puedes vincular la campaña al producto ya que pertenecen a diferentes vendedores.",
    VENDOR_SEARCH_TIPS: "Buscar producto, cliente, etc.",
    VENDOR_PRODUCT_ID: "ID del Producto",
    VENDOR_COUNTRY: "País",
    VENDOR_REMOVE_FROM_CAMP: "eliminar de las campañas",
    VENDOR_CUSTOMERS: "Clientes",
    VENDOR_HEAD: "Encabezado",
    VENDOR_USER_NAME: "Nombre de usuario",
    VENDOR_USER_ID: "ID de usuario",
    VENDOR_EMAIL_ADDRESS: "Dirección de correo electrónico",
    VENDOR_PHONE_NUMBER: "Número de teléfono",
    VENDOR_BACK_TO_CUSTOMER_LIST: "Volver al listado de clientes",
    VENDOR_USER_PROFILE: "Perfil de usuario",
    VENDOR_UPDATE_PROFILE: "Actualización del perfil",
    VENDOR_FIRST_ROMAN_NAME: "Nombre latino",
    VENDOR_LAST_ROMAN_NAME: "Apellido latino",
    VENDOR_FIRST_NATIVE_NAME: "Nombre nativo",
    VENDOR_LAST_NATIVE_NAME: "Apellido nativo",
    VENDOR_ADD_LINE_1: "Dirección línea 1",
    VENDOR_ADD_LINE_2: "Dirección línea 2",
    VENDOR_CITY: "Ciudad",
    VENDOR_STATE: "Comunidad autónoma",
    VENDOR_ZIP_CODE: "Código postal",
    VENDOR_BIO: "Bio",
    VENDOR_BIO_TIPS:
      "Hazla breve y simple. Descríbete al mundo. Esta será tu biografía para que todos la vean.",
    VENDOR_STATUS: "Estado",
    VENDOR_ORDER_HISTORY: "Historial de pedidos",
    VENDOR_ORDERS: "Pedidos",
    VENDOR_DATE: "Fecha",
    VENDOR_CUSTOMER: "Cliente",
    VENDOR_PAYMENT_STATUS: "Estado del pago",
    VENDOR_FULFILLMENT_STATUS: "Estado de realización",
    VENDOR_PRICE: "Precio",
    VENDOR_ALL_ORDERS: "Todos los pedidos",
    VENDOR_OPERATE: "Funcionar",
    VENDOR_EXPORT: "Exportar",
    VENDOR_ORDER_ID: "ID del pedido",
    VENDOR_MARK_AS_FULFILLED: "Marcar como realizado",
    VENDOR_ALL_STATUS: "Todos los estados",
    VENDOR_PLS_SELECT: "Selecciona",
    VENDOR_START_TIME_TO_END_TIME: "Fecha de inicio - Fecha fin",
    VENDOR_PLS_INPUT_STTET: "¡Introduce la fecha de inicio - fecha fin!",
    VENDOR_TRACKING: "Seguimiento",
    VENDOR_REFUNDED: "Reembolsado",
    VENDOR_STAFF_DELETE_TIPS: "¿Seguro que quieres borrarlo?",
    VENDOR_STAFF: "Personal",
    VENDOR_ADD_STAFF: "Añadir personal",
    VENDOR_FULL_NAME: "Nombre completo",
    VENDOR_DEPARTMENT: "Departamento",
    VENDOR_ROLE: "Cargo",
    VENDOR_ADD: "Añadir",
    VENDOR_PFTFB: "Rellena el siguiente formulario.",
    VENDOR_PWD: "Contraseña",
    VENDOR_PSYR: "¡Selecciona tu cargo!",
    VENDOR_PIYUI: "¡Introduce tu ID de usuario!",
    VENDOR_PIYUN: "¡Introduce tu nombre de usuario!",
    VENDOR_PIYP: "¡Introduce tu contraseña!",
    VENDOR_PIYE: "¡Introduce tu correo electrónico!",
    VENDOR_BSE: "Comprar. Compartir. Ganar.",
    VENDOR_BSE_DESC:
      "Kwik es una nueva plataforma de marketplace que conecta las marcas con sus mayores seguidores, creando una poderosa fuerza de ventas del boca a boca.",
    VENDOR_PETIMBTAYA:
      "Introduce la información que se menciona a continuación para acceder a tu cuenta.",
    VENDOR_PIYEOU: "¡Introduce tu correo electrónico o nombre de usuario!",
    VENDOR_KEEP_SIGN_IN: "Permanecer conectado",
    VENDOR_DONT_HAVE_ACCOUNT: "¿Todavía no tienes cuenta?",
    VENDOR_CREATE_ONE: "Crear cuenta",
    VENDOR_PPTREATRP:
      "Proporciona la dirección de correo electrónico registrada para restablecer la contraseña.",
    VENDOR_ALREADY_KNOW_PASSWORD: "Ya sé la contraseña",
    VENDOR_GO_TO_SIGNIN: "Ir a Iniciar sesión",
    VENDOR_PCYI_CTLTRYP:
      "Revisa tu bandeja de entrada y haz clic en el enlace para restablecer tu contraseña.",
    VENDOR_DIDNOT_RECEIVE_THE_LINK: "¿No has recibido el enlace?",
    VENDOR_CHOOSE_NEW_PWD: "Elige una contraseña nueva",
    VENDOR_EAUPTCYNP:
      "Introduce una contraseña única para crear tu nueva contraseña",
    VENDOR_NEW_PWD: "Nueva contraseña",
    VENDOR_PIYCP: "¡Introduce tu contraseña confirmada!",
    VENDOR_SUCESS: "Hecho",
    VENDOR_YAHBC_PL: "Tu cuenta ha sido creada. Inicia sesión",
    VENDOR_CYBAN: "Crea tu cuenta de negocio ahora.",
    VENDOR_PPUWSITCYA:
      "Nos tienes que facilitar algunos datos para crear tu cuenta.",
    VENDOR_BUSINESS_NAME: "Nombre de la empresa",
    VENDOR_PIBN: "Introduce el nombre de la empresa",
    VENDOR_BPN: "Número de teléfono de la empresa",
    VENDOR_PIPN: "Introduce el número de teléfono",
    VENDOR_EAFCA: "Dirección de correo electrónico para la cuenta de empresa",
    VENDOR_PIEA: "Introduce la dirección de correo electrónico",
    VENDOR_PIP: "Introduce la contraseña",
    VENDOR_CYP: "Confirmar tu contraseña",
    VENDOR_PICP: "Introduce la contraseña de confirmación",
    VENDOR_INCONSISTENT_PWD: "Las contraseñas no coinciden",
    VENDOR_IAGREETOTHE: "Acepto los",
    VENDOR_TERMS_CONDITIONS: "términos y condiciones",
    VENDOR_PCTT_CONDITONS_AGREEMENT:
      "¡Consulta los términos y condiciones del contrato!",
    VENDOR_BUSINESS_INFO: "Información de la empresa",
    VENDOR_BUSINESS_INFO_DESC:
      "Ten en cuenta que esta información no es necesaria en el momento del registro, pero es necesaria para la puesta en marcha.",
    VENDOR_BUSINESS_TYPE: "Tipo de empresa",
    VENDOR_PLS_INPUT_BUSINESS_TYPE: "Introduce el tipo de empresa",
    VENDOR_SSN_EIN: "N.º SS (o N.º de empleador)",
    VENDOR_PLS_INPUT_SSN: "Introduce el N.º SS",
    VENDOR_WHO_REFER_YOU_TO_KWIK: "¿Quién te remitió a Kwik?",
    VENDOR_JSWCGTCTTRP:
      "Solo para que podamos darle el crédito a la persona correcta.",
    VENDOR_PLS_INPUT_FN: "Introduce el nombre",
    VENDOR_PLS_INPUT_LN: "Introduce el apellido",
    VENDOR_PLS_INPUT_EA: "Introduce la dirección de correo electrónico",
    VENDOR_BRAND_INDUSTRY: "Sector de la marca",
    VENDOR_PLS_INPUT_BRAND_INDUSTRY: "Selecciona el sector de de la marca",
    VENDOR_CONTACT_INFO: "Información de contacto",
    VENDOR_CONTACT_INFO_DESC:
      "Tu marca quedará pendiente hasta que haya sido aprobada. Necesitamos a alguien a quien contactar.",
    VENDOR_BUSINESS_URL: "URL comercial",
    VENDOR_CR:
      "Ingresos de la empresa (ingresos anuales del ejercicio anterior)",
    VENDOR_PLS_INPUT_CR: "Introduce los ingresos de la empresa",
    VENDOR_SUCCESS: "Hecho",
    VENDOR_REGISTER_SUCCESS_1:
      "Gracias por completar la información del perfil de la marca.",
    VENDOR_REGISTER_SUCCESS_2:
      "Un miembro de nuestro Equipo de Marcas se pondrá en contacto contigo en breve para recabar más información y ayudarte a incorporar tus productos a Kwik",
    VENDOR_REGISTER_SUCCESS_3: "Gracias por tu paciencia.",
    VENDOR_REGISTER_SUCCESS_4: "Tiempo estimado: 1-3 días",
    VENDOR_KWIK_HOME: "Inicio Kwik",
    VENDOR_STILL_PENDING: "Aún pendiente",
    VENDOR_REGISTER_PENDING_1:
      "Disculpa, nuestro equipo de Gestión de Marcas está muy ocupado en este momento y la incorporación está tardando más de lo esperado.",
    VENDOR_REGISTER_PENDING_2:
      "Estamos haciendo lo posible para que todas las marcas estén en Kwik.",
    VENDOR_REGISTER_PENDING_3:
      "Utiliza las credenciales de acceso de tu marca para entrar y ver lo que verían los usuarios",
    VENDOR_CHECK_OUT_USER: "Consulta la experiencia del usuario",
    VENDOR_USER_USERNAME: "Nombre de usuario",
    DASHBOARD_HI_USER_NAME: "Hola,{{userName}}",
    DASHBOARD_ANALYTIC_REPORT: "Informe analítico",
    DASHBOARD_SEARCH_FOR_PRODUCT_PLACEHOLDER: "Buscar producto, cliente, etc.",
    DASHBOARD_TOTAL_EARNINGS: "Total ganancias",
    DASHBOARD_EARNINGS_REPORT: "Informe de ganancias",
    DASHBOARD_HERE_IS_THE_UPDATE_OF_YOUR_EARNING:
      "Estas son las actualizaciones de tus ganancias.",
    DASHBOARD_THIS_WEEK_ITEM: "Esta semana",
    DASHBOARD_THIS_MONTH_ITEM: "Este mes",
    DASHBOARD_THIS_YEAR_ITEM: "Este año",
    DASHBOARD_YOUR_TOTAL_EARNINGS: "Tu total de ganancias",
    DASHBOARD_GET_ALL_THE_EARNING_MESSAGE:
      "Obtén todas las ganancias de la semana, mes, año en un solo lugar.",
    DASHBOARD_REVENUE: "Ingresos",
    DASHBOARD_USERS: "Usuarios",
    DASHBOARD_ALL_USERS: "Todos los usuarios",
    DASHBOARD_NEW_USERS: "Usuarios nuevos",
    DASHBOARD_TOP_SELLING_PRODUCTS: "Productos más vendidos",
    DASHBOARD_IMAGE_TH: "Imagen",
    DASHBOARD_PRODUCT_NAME_TH: "Nombre del producto",
    DASHBOARD_STATUS_TH: "Estado",
    DASHBOARD_PRICE_TH: "Precio",
    DASHBOARD_SALES_TH: "Ventas",
    DASHBOARD_KWIKCASH_VALUE_TH: "Valor de KwikCash",
    DASHBOARD_INVENTORY_IN_STOCK: "{{inventory}} en stock",
    DASHBOARD_TOP_EARNERS: "Los que más ganan",
    DASHBOARD_ACTIVITY: "Actividad",
    DASHBOARD_PURCHASED: "comprada",
    PRODUCTS_PRODUCTS_TITLE: "Productos",
    PRODUCTS_IMAGE_TH: "Imagen",
    PRODUCTS_PRODUCT_NAME_TH: "Nombre del producto",
    PRODUCTS_PRODUCT_ID_TH: "ID del Producto",
    PRODUCTS_COUNTRY_TH: "País",
    PRODUCTS_CURRENCY_TH: "Divisa",
    PRODUCTS_TYPE_TH: "Tipo",
    PRODUCTS_PRICE_TH: "Precio",
    PRODUCTS_BUDGET_TH: "Presupuesto",
    PRODUCTS_KWIKCASH_VALUE_TH: "Valor de KwikCash",
    PRODUCTS_ACTIONS_TH: "Acciones",
    PRODUCTS_EDIT_BUTTON: "Editar",
    PRODUCTS_PREVIEW_BUTTON: "    Vista previa",
    PRODUCTS_DETAIL_UPDATE_PRODUCT: "Actualizar producto",
    PRODUCTS_DETAIL_ADD_PRODUCT: "Añadir producto",
    PRODUCTS_DETAIL_PLEASE_FILL_THE_FORM_BELLOW:
      "Rellena el siguienteformulario.",
    PRODUCTS_DETAIL_CANCEL_BUTTON: "Cancelar",
    PRODUCTS_DETAIL_SAVE_PRODUCT: "Guardar producto",
    PRODUCTS_DETAIL_COUNTRY: "País",
    PRODUCTS_DETAIL_PLEASE_SELECT_COUNTRY: "¡Selecciona el país!",
    PRODUCTS_DETAIL_PLEASE_SELECT_WAREHOUSE: "    ¡Seleccionar almacén!",
    PRODUCTS_DETAIL_SELECT_COUNTRY: "Seleccionar país",
    PRODUCTS_DETAIL_CURRENCY: "Divisa",
    PRODUCTS_DETAIL_SELECT_CURRENCY: "Seleccionar divisa",
    PRODUCTS_DETAIL_WAREHOUSE: "Almacén",
    PRODUCTS_DETAIL_SELECT_WAREHOUSE: "Seleccionar almacén",
    PRODUCTS_DETAIL_GENERAL_INFO: "Información general",
    PRODUCTS_DETAIL_PRODUCT_NAME: "Nombre del producto",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_PRODUCT_NAME:
      "¡Introduce el nombre de tu producto!",
    PRODUCTS_DETAIL_PRODUCT_SHORT_DESCRIPTION:
      "Breve descripción del producto (limitada a 200 caracteres)",
    PRODUCTS_DETAIL_ADD_PRODUCT_IMAGE: "Añadir imagen de producto",
    PRODUCTS_DETAIL_REMOVE: "Eliminar",
    PRODUCTS_DETAIL_DRAG_AND_DROP: "ARRASTRAR Y SOLTAR",
    PRODUCTS_DETAIL_YOUR_FILES_TO_ASSETS:
      "tus archivos a los recursos, o <span>navegar</span>",
    PRODUCTS_DETAIL_ACCEPTED_FILE_TYPE:
      "Tipos de archivos aceptados: PNG, JPEG únicamente. ",
    PRODUCTS_DETAIL_RETURN_POLICY: "Política de devoluciones",
    PRODUCTS_DETAIL_PLEASE_ENTER_THE_NUMBER: "Introduce el número",
    PRODUCTS_DETAIL_DAYS: "Días",
    PRODUCTS_DETAIL_ADD_PRODUCT_VIDEO: "Añadir vídeo del producto",
    PRODUCTS_DETAIL_VIDEO_URL: "URL del vídeo",
    PRODUCTS_DETAIL_PRICING: "Fijación de precios",
    PRODUCTS_DETAIL_PRICE: "Precio",
    PRODUCTS_DETAIL_COMPARE_AT_PRICE: "Comparar a precio (precio de venta)",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_SALE_PRICE:
      "¡Introduce tu precio de venta!",
    PRODUCTS_DETAIL_BUDGET: "Presupuesto",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_BUDGET: "¡Introduce tu presupuesto!",
    PRODUCTS_DETAIL_FULL_KWIK_CASH: "KwikCash completo",
    PRODUCTS_DETAIL_1ST_WAVE_COMMISSION_RATE: "Tasa de comisión de 1.ª onda",
    PRODUCTS_DETAIL_VAT_RATE: "Tasa de IVA",
    PRODUCTS_DETAIL_TAX_RATE: "Tasa de IVA",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_VAT_RATE: "¡Introduce tu tasa de IVA!",
    PRODUCTS_DETAIL_VAT_INCLUSIVE: "IVA incluido",
    PRODUCTS_DETAIL_TAX_INCLUSIVE: "IVA incluido",
    PRODUCTS_DETAIL_TAX_CATEGORY: "Categoría fiscal",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_TAX_CATEGORY:
      "¡Introduce tu categoría fiscal!",
    PRODUCTS_DETAIL_DUTY_RATE: "Tasa arancelaria",
    PROUDCTS_DETAIL_DUTY_INCLUSIVE: "Aranceles incluidos",
    PRODUCTS_DETAIL_NEWAGE_CAMPAIGN: "Campaña de NewAge",
    PRODUCTS_DETAIL_FULFILED_BY_NEWAGE: "Realizado por NewAge",
    PRODUCTS_DETAIL_PV: "PV",
    PRODUCTS_DETAIL_INVENTORY: "Inventario",
    PRODUCTS_DETAIL_SKU_STOCK_KEPING_UNIT: "SKU (Número de referencia único)",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_SKU: "¡Introduce tu SKU!",
    PRODUCTS_DETAIL_QUANTITY: "Cantidad",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_INVENTORY: "¡Introduce tu inventario!",
    PRODUCTS_DETAIL_SHIPPING: "Envío",
    PRODUCTS_DETAIL_WEIGHT: "Peso",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_WEIGHT: "¡Introduce tu peso!",
    PRODUCTS_DETAIL_CANADA_NFR_LIMITS: "Límites de NFR de Canadá",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_NFR_LIMITS:
      "¡Introduce tus límites de NFR!",
    PRODUCTS_DETAIL_PRODUCT_STATUS: "Estado del producto",
    PRODUCTS_DETAIL_SCHEDULE_LAUNCH_TIME: "Programar hora de lanzamiento",
    PRODUCTS_DETAIL_PRODUCT_LONG_DESCRIPTION: "Descripción larga del producto",
    PRODUCTS_DETAIL_ORGANIZATION: "Organización",
    PRODUCTS_DETAIL_PRODUCT_CATEGORY: "Categoría de producto",
    PRODUCTS_DETAIL_PLEASE_SELECT_YOUR_PRODUCT_CATEGORY:
      "¡Selecciona tu categoría de producto!",
    PRODUCTS_DETAIL_PLEASE_SELECT: "Selecciona",
    PRODUCTS_DETAIL_SUBCATEGORY: "Subcategoría",
    PRODUCTS_DETAIL_PLEASE_SELECT_YOUR_SUBCATEGORY:
      "¡Selecciona tu subcategoría!",
    PRODUCTS_DETAIL_VARIANTS_INFO: "Información de variantes",
    PRODUCTS_DETAIL_VARIANT_NAME: "Nombre de la variante",
    PRODUCTS_DETAIL_ADD_OPTION: "Añadir opción",
    PRODUCTS_DETAIL_ADD_VARIANT: "Añadir variante",
    PRODUCTS_DETAIL_VARIANTS_TH: "Variantes",
    PRODUCTS_DETAIL_IMAGE_URL_TH1: "    Imagen1",
    PRODUCTS_DETAIL_IMAGE_URL_TH2: "    Imagen2",
    PRODUCTS_DETAIL_IMAGE_URL_TH3: "    Imagen3",
    PRODUCTS_DETAIL_IMAGE_URL_TH4: "    Imagen4",
    PRODUCTS_DETAIL_DETELE_TH: "Borrar",
    PRODUCTS_DETAIL_DELETE_IT_TH: "¿Borrar?",
    PRODUCTS_DETAIL_SKU_TH: "SKU",
    PRODUCTS_DETAIL_PRICE_TH: "PRECIO",
    PRODUCTS_DETAIL_COMPARE_TO_TH: "COMPARAR_CON",
    PRODUCTS_DETAIL_POINTS_TH: "Puntos",
    PRODUCTS_DETAIL_BUDGET_TH: "PRESUPUESTO",
    PRODUCTS_DETAIL_KCASH_TH: "KCASH",
    PRODUCTS_DETAIL_INVENTORY_TH: "INVENTARIO",
    PRODUCTS_DETAIL_START_DATE_TH: "FECHA_INICIO",
    PRODUCTS_DETAIL_END_DATE_TH: "FECHA_FIN",
    PRODUCTS_DETAIL_STATUS_TH: "ESTADO",
    PRODUCTS_DETAIL_ACTIVE: "Activo",
    PRODUCTS_DETAIL_HIDDEN: "Oculto",
    PRODUCTS_DETAIL_WEIGHT_TH: "PESO",
    WAREHOUSE_PRODUCTS: "Productos",
    WAREHOUSE_WAREHOUSE: "Almacén",
    WAREHOUSE_ADD_WAREHOUSE_BUTTON: "Añadir almacén",
    WAREHOUSE_NAME_TH: "Nombre",
    WAREHOUSE_COUNTRY_TH: "País",
    WAREHOUSE_ADDRESS1_TH: "Dirección 1",
    WAREHOUSE_ADDRESS2_TH: "Dirección 2",
    WAREHOUSE_CITY_TH: "Ciudad",
    WAREHOUSE_STATE_TH: "Estado",
    WAREHOUSE_POSTAL_CODE_TH: "Código postal",
    WAREHOUSE_CONTACT_TH: "Contacto",
    WAREHOUSE_PHONE_TH: "Teléfono",
    WAREHOUSE_SHIPPING_VENDOR_TH: "Proveedor de envío",
    WAREHOUSE_ACTIONS_TH: "Acciones",
    WAREHOUSE_EDIT_BUTTON: "Editar",
    WAREHOUSE_DETAIL_BACK_TO_WAREHOUSE_LIST: "Volver al listado de almacenes",
    WAREHOUSE_DETAIL_WAREHOUSE_DETAIL: "Detalle del almacén",
    WAREHOUSE_DETAIL_UPDATE: "Actualizar",
    WAREHOUSE_DETAIL_SAVE: "Guardar",
    WAREHOUSE_DETAIL_CANCEL: "Cancelar",
    WAREHOUSE_DETAIL_FORM_NAME: "Nombre",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_NAME: "¡Introduce el nombre!",
    WAREHOUSE_DETAIL_FORM_COUNTRY: "País",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_COUNTRY: "¡Introduce el país!",
    WAREHOUSE_DETAIL_FORM_SELECT_COUNTRY: "Seleccionar país",
    WAREHOUSE_DETAIL_FORM_PLEASE_SELECT: "Selecciona",
    WAREHOUSE_DETAIL_FORM_ADDRESS1: "Dirección 1",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_ADDR1:
      "¡Introduce la línea 1 de la dirección!",
    WAREHOUSE_DETAIL_FORM_ADDRESS2: "Dirección 2",
    WAREHOUSE_DETAIL_FORM_CITY: "Ciudad",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_CITY: "¡Introduce la ciudad!",
    WAREHOUSE_DETAIL_FORM_STATE: "Comunidad autónoma",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_STATE:
      "¡Introduce la comunidad autónoma!",
    WAREHOUSE_DETAIL_FORM_POSTAL_CODE: "Código postal",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_POSTAL_CODE:
      "¡Introduce el código postal!",
    WAREHOUSE_DETAIL_FORM_CONTACT: "Contacto",
    WAREHOUSE_DETAIL_FORM_PHONE: "Teléfono",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_PHONE: "¡Introduce el teléfono!",
    WAREHOUSE_DETAIL_FORM_SHIPPING_VENDOR: "Proveedor de envío",
    INVENTORY_PRODUCTS: "Productos",
    INVENTORY_INVENTORY: "Inventario",
    INVENTORY_IMAGE: "Imagen",
    INVENTORY_PRODUCT_NAME: "Nombre del producto",
    INVENTORY_SUPPLIER: "Proveedor",
    INVENTORY_SKU: "N.º SKU",
    INVENTORY_QTY_ALLOTED: "Cantidad asignada",
    INVENTORY_QTY_SOLD: "Cantidad vendida",
    INVENTORY_QTY_ON_HAND: "Cantidad disponible",
    INVENTORY_SALES: "Ventas",
    SIDEBAR_MENU: "Menú",
    SIDEBAR_OVERVIEW: "Vista general",
    SIDEBAR_PRODUCTS: "Productos",
    SIDEBAR_WAREHOUSE: "Almacén",
    SIDEBAR_INVENTORY: "Inventario",
    SIDEBAR_ADD_PRODUCT: "Añadir producto",
    SIDEBAR_GRAPH_VIEW: "Vista de gráfico",
    SIDEBAR_CAMPAIGNS: "Campañas",
    SIDEBAR_CREATE_EDIT_CAMPAIGNS: "Crear/editar campañas",
    SIDEBAR_MAP_CAMPAIGNS_PRODUCTS: "Mapear campañas/productos",
    SIDEBAR_CUSTOMERS: "Clientes",
    SIDEBAR_ORDERS: "Pedidos",
    SIDEBAR_PAYOUTS: "Pagos",
    SIDEBAR_STAFF_MANAGEMENT: "Gestión de personal",
    SIDEBAR_SETTINGS: "Ajustes",
    SETTINGS_GENERAL_STORE_DETAILS: "Detalles de la tienda",
    SETTINGS_GENERAL_STORE_ADDRESS: "    Dirección de comercio",
    SETTINGS_GENERAL_YOUR_CUSTOMERS_WILL_MESSAGE:
      "Tus clientes usarán esta información para contactar contigo.",
    SETTINGS_GENERAL_STORE_NAME: "Nombre de la tienda",
    SETTINGS_GENERAL_CONTACT_EMAIL: "Correo electrónico de contacto",
    SETTINGS_GENERAL_ADD_LOGO: "Añadir logotipo",
    SETTINGS_GENERAL_DRAG_AND_DROP: "ARRASTRAR Y SOLTAR",
    SETTINGS_GENERAL_YOUR_FILES_TO_ASSETS: "<span>navegar</span>",
    SETTINGS_ACCEPTED_FILE_TYPE:
      "Tipos de archivos aceptados: PNG, JPEG únicamente. ",
    SETTINGS_ACCEPTED_ADD_HERO_BANNER: "Añadir banner de héroe",
    SETTINGS_ACCEPTED_REMOVE: "Eliminar",
    SETTINGS_GENERAL_UPLOAD_TERMS_AND_CONDITIONS:
      "Subir Términos y Condiciones",
    SETTINGS_GENERAL_ENTER_YOUR_TEXT: "Introduce tu texto",
    SETTINGS_GENERAL_STORE_INFORMATION: "Guardar información",
    SETTINGS_GENERAL_SHARE_BIO_LIMIT_CHARACTERS:
      "Compartir bio (límite de 120 caracteres)",
    SETTINGS_GENERAL_COPY_AND_PASTE_YOUR_MESSAGE:
      "Copia y pega tus términos y condiciones aquí",
    SETTINGS_GENERAL_ENTER_URL_S: "Introduce las URL",
    SETTINGS_GENERAL_WEBSITE_URL: "URL del sitio web",
    SETTINGS_GENERAL_FACEBOOK_URL: "URL de Facebook ",
    SETTINGS_GENERAL_INSTAGRAM_URL: "URL de Instagram",
    SETTINGS_GENERAL_TWITTER_URL: "URL de Twitter",
    SETTINGS_GENERAL_UPLOAD_RETURN_POLICY_HERE:
      "Subir política de devoluciones aquí",
    SETTINGS_GENERAL_UPLOAD_SHIPPING_POLICY_HERE:
      "Subir política de envío aquí",
    SETTINGS_GENERAL_ACTIVE_STATUS: "Estado activo",
    SETTINGS_GENERAL_PENDING: "Pendiente",
    SETTINGS_GENERAL_APPROVED: "Aprobado",
    SETTINGS_GENERAL_LIVE: "En línea",
    SETTINGS_GENERAL_DISCARD: "Descartar",
    SETTINGS_GENERAL_SAVE: "Guardar",
    SETTINGS_PROFILE_SAVE_PROFILE: "Guardar perfil",
    SETTINGS_PROFILE_PREVIEW: "Vista previa",
    SETTINGS_BANKINFO_CONNECT_BANK_ACCOUNT: "Conectar cuenta bancaria",
    SETTINGS_BANKINFO_ACCEPT_PAYMENTS_ON_YOUT_MESSAGE:
      "Aceptar pagos en tu tienda utilizando proveedores externos como PayPal u otros métodos de pago",
    SETTINGS_BANKINFO_ADD_BANK_ACCOUNT: "Añadir cuenta bancaria",
    SETTINGS_BANKINFO_EDIT: "Editar",
    SETTINGS_BANKINFO_MANUAL_VERIFICATION: "Verificación manual",
    SETTINGS_BANKINFO_AT_KWIK_YOUR_SECURITY_MESSAGE:
      "En Kwik tu seguridad es muy importante para nosotros por lo que vamos a verificar tu cuenta bancaria haciendo dos ingresos muy pequeños en tu cuenta. Introduce esos importes cuando aparezcan en tu cuenta",
    SETTINGS_BANKINFO_GO_BACK: "Volver",
    SETTINGS_BANKINFO_CONTINUE: "Continuar",
    SETTINGS_BANKINFO_PLEASE_VERIFY_THE_MESSAGE:
      "Comprueba los pequeños ingresos que hemos realizado en tu(s) cuenta(s)",
    SETTINGS_BANKINFO_CHARGE1: "Cargo 1",
    SETTINGS_BANKINFO_ENTER_AMOUNT: "Introduce el importe",
    SETTINGS_BANKINFO_CHARGE2: "Cargo 2",
    SETTINGS_BANKINFO_TO_VERIFY_YOUR_MESSAGE:
      "Para verificar tu cuenta bancaria, verás dos ingresos y dos reintegros en tu extracto bancario en los próximos dos o tres días. Cada uno será de menos de 1 $USD ",
    SETTINGS_BANKINFO_PLEASE_MAKE_SURE_MESSAGE:
      "Procura que haya un saldo de al menos 2 $USD para evitar comisiones por descubierto",
    SETTINGS_BANKINFO_BANK_ROUTING_NUMBER: "Número de enrutamiento bancario",
    SETTINGS_BANKINFO_ROUTING_NUMBER: "Número de ruta",
    SETTINGS_BANKINFO_ACCOUNT_NUMBER: "Número de cuenta",
    SETTINGS_BANKINFO_CONFIRM_ACCOUNT_NUMBER: "Confirmar número de cuenta",
    SETTINGS_BANKINFO_ACCOUNT_NAME: "Nombre de la cuenta",
    SETTINGS_BANKINFO_ENTER_ACCOUNT_NAME: "Introduce el nombre de la cuenta",
    SETTINGS_BANKINFO_SET_YOUR_SHIPPING_RATES: "Fija tus tarifas de envío",
    SETTINGS_BANKINFO_SET_YOUR_VARIOUS_SHIPPING_RATES:
      "Fija tus diferentes tarifas de envío",
    SETTINGS_BANKINFO_ADD_RATE: "Añadir tarifa",
    SETTINGS_BANKINFO_ADD_A_NEW_SHIPPING_RATES:
      "Añadir una nueva tarifa de envío",
    SETTINGS_BANKINFO_PRICING: "Fijación de precios",
    SETTINGS_BANKINFO_ADD_CONDITIONS: "Añadir condiciones",
    SETTINGS_BANKINFO_BASED_ON_ITEM_WEIGHT: "En función del peso del artículo",
    SETTINGS_BANKINFO_BASED_ON_ORDER_PRICE: "En función del precio del pedido",
    SETTINGS_BANKINFO_NUMBER_OF_UNITS: "Número de unidades",
    SETTINGS_BANKINFO_SAVE_RATE: "Guardar tarifa",
    SETTINGS_BANKINFO_CANCEL: "Cancelar",
    SETTINGS_SHIPPINGCOST_SHOW_ALL: "Mostrar todo",
    SETTINGS_SHIPPINGCOST_ADD_SHIPPING_FORMULA: "Añadir fórmula de envío",
    SETTINGS_SHIPPINGCOST_EDIT_SHIPPING_FORMULA: "Editar fórmula de envío",
    SETTINGS_SHIPPINGCOST_SAVE: "Guardar",
    SETTINGS_SHIPPINGCOST_SKU_ID: "ID de SKU",
    SETTINGS_SHIPPINGCOST_PRODUCT_NAME: "Nombre del producto",
    SETTINGS_SHIPPINGCOST_DELETE: "Borrar",
    SETTINGS_SHIPPINGCOST_BY_PRICE: "Por precio",
    SETTINGS_SHIPPINGCOST_BY_WEIGHT: "Por peso",
    SETTINGS_SHIPPINGCOST_BY_COUNT: "Por recuento",
    SETTINGS_SHIPPINGCOST_FROM_PRICE: "Desde precio",
    SETTINGS_SHIPPINGCOST_TO_PRICE: "Hasta precio",
    SETTINGS_COUNTRY_CODE: "    Código de país",
    SETTINGS_VAT_ID: "    Número fiscal",
    SHIPPINGS_SHIPPINGCOST_FROM_LBS: "Desde kg",
    SHIPPINGS_SHIPPINGCOST_TO_LBS: "Hasta kg",
    SHIPPINGS_SHIPPINGCOST_FROM_COUNTS: "De recuento",
    SHIPPINGS_SHIPPINGCOST_TO_COUNTS: "Hasta recuento",
    SHIPPINGS_SHIPPINGCOST_PLEASE_SELECT_VENDOR: "selecciona proveedor",
    SHIPPINGS_SHIPPINGCOST_PLEASE_SELECT_SHIPPING_METHOD:
      "Selecciona el método de envío",
    SHIPPINGS_SHIPPINGCOST_ITEM_ALREADY_EXISTS: "El artículo ya existe",
    SHIPPINGS_SHIPPINGCOST_TO_PRICE_CANNOT_BE_ADDED:
      "Hasta precio es #{{unlimited}} y no se pueden añadir nuevos datos",
    SHIPPINGS_SHIPPINGCOST_TO_LBS_CANNOT_BE_ADDED:
      "Hasta kg es #{{unlimited}} y no se pueden añadir nuevos datos",
    SHIPPINGS_SHIPPINGCOST_TO_COUNT_CANNOT_BE_ADDED:
      "Hasta recuento es #{{unlimited}} y no se pueden añadir nuevos datos",
    SHIPPINGS_SHIPPINGCOST_FORMULA_save_successfully:
      "Fórmula(s) guardada(s) correctamente",
    SHIPPINGS_SHIPPINGCOST_DATA_MUST_NOT_BE_EMPTY:
      "Los datos no deben estar vacíos",
    SHIPPINGS_SHIPPINGCOST_TO_PRICE_DATA_FORMAT_ERROR:
      "Error de formato de datos en hasta precio",
    SHIPPINGS_SHIPPINGCOST_TO_LBS_DATA_FORMAT_ERROR:
      "Error de formato de datos en hasta kg",
    SHIPPINGS_SHIPPINGCOST_TO_COUNT_DATA_FORMAT_ERROR:
      "Error de formato de datos en hasta recuento",
    SHIPPINGS_SHIPPINGCOST_PLEASE_EDIT_UNDER_THE_CORRESPONDING_TYPE:
      "Edita bajo el tipo correspondiente",
    SHIPPINGS_SHIPPINGCOST_NUMBERS_CAN_NOT_BE_NEGATIVE:
      "los números no pueden ser negativos",
    CHECKOUT_PAGE_MY_CART: "Mi carrito",
    CHECKOUT_PAGE_SHIPPING_ADDRESS: "Dirección de envío",
    CHECKOUT_PAGE_SAVE: "Guardar",
    CHECKOUT_PAGE_CHANGE: "Cambio",
    CHECKOUT_FIELD_NAME: "Nombre",
    CHECKOUT_FIELD_ADDRESS: "Dirección",
    CHECKOUT_FIELD_APT_SUITE_ETC: "Apto., hab., etc. (Opcional)",
    CHECKOUT_FIELD_CITY: "Ciudad",
    CHECKOUT_FIELD_ZIP: "Código postal",
    CHECKOUT_FIELD_PROVINCE: "Provincia",
    CHECKOUT_FIELD_STATE: "Comunidad autónoma",
    CHECKOUT_IS_BILLING_ADDRESS_DIFFERENT:
      "¿La dirección de facturación es diferente?",
    CHECKOUT_ITEM: "artículo",
    CHECKOUT_ITEMS: "artículos",
    CHECKOUT_PLEASE_FILL_OUT_NAME_FOR_CARD: "Introduce el nombre de la tarjeta",
    CHECKOUT_TEXT_CHECKOUT: "Pago",
    CHECKOUT_ENTER_CREDIT_CARD: "Introducir tarjeta de crédito",
    CHECKOUT_FIRST: "Nombre de pila",
    CHECKOUT_LAST: "Apellido",
    CHECKOUT_SAVE_SAVE_TO_MY_ACCOUNT: "Guardar tarjeta en mi cuenta",
    CHECKOUT_BY_CLICKING_CONFIRM_MESSAGE:
      "Al hacer clic en Confirmar, aceptas la <span>Política de privacidad</span> y los <span> Términos y condiciones de Kwik </span>",
    CHECKOUT_CONFIRM: "Confirmar",
    CHECKOUT_CARD_NUMBER: "Número de tarjeta",
    CHECKOUT_CARD_MM_YY: "MM/AA",
    CHECKOUT_CARD_CVC: "CVV",
    CHECKOUT_BILLING_ADDRESS: "Dirección de facturación",
    CHECKOUT_SAVE_ADDRESS: "Guardar dirección",
    CHECKOUT_SAVE_SUCCESS: "Guardado correctamente",
    CHECKOUT_SAVE_FAILED:
      "Rellena el siguiente formulario. Todos los campos son obligatorios",
    SHARING_PRO_YOU_CAN_SHARE: "Productos que puedes compartir",
    SHARING_UWTTEE: "Utiliza Waves Tech para ganar exponencialmente",
    SHARING_UWTTEE_DESC:
      "La herramienta para aprovechar tu verdadero potencial para ganar en línea y maximizar tu verdadera influencia. Coge un enlace de abajo para poner a prueba la tecnología de Kwik Waves y que te paguen por tu verdadera influencia.",
    SHARING_CLOSE: "Cerrar",
    SHARING_FIVE_TIMES: "Solo verás esto 5 veces más",
    SHARING_SHARE_FULL_CAMP: "Compartir campaña completa",
    SHARING_SINGLE_PRO: "Compartir un solo producto",
    SHARING_MOST_SHARED: "Enlace más compartido de",
    ALL_PRO_POLICIES: "Políticas",
    SS_THANK_YOU: "Gracias",
    SS_SHARE_TIPS:
      "¿Te gusta mucho tu compra? ¡Estupendo! ¿Por qué no recibir una recompensa por compartir este producto con un amigo?",
    SS_SHARE_TIPS_DESC:
      "¡Crea una cuenta y comienza a compartir tus KwikLinks! Tu enlace rastrea las compras realizadas por amigos y familiares, y las comisiones por recomendación se ingresan directamente en tu cuenta de Kwik.",
    SS_CUSTOMER_INFO: "Información al cliente",
    SS_ADDRESS_INFO: "Datos del domicilio",
    SS_CHECK_YOUR_EARNING: "Verifique sus ganancias",
    SS_WHMIETSYA: "Hemos simplificado la creación de tu cuenta.",
    SS_RETURN_HOME: "Volver a inicio",
    SS_CREATE_HOME: "Crear una cuenta",
    SS_NEWAGE_PV: "PV de NewAge",
    SS_FOOTER_HEAR_YOU: "Nos encantaría tener noticias tuyas",
    SS_FOOTER_EMAIL: "support@wer1.com",
    SS_FOOTER_PPTOU: "Política de privacidad | Términos de uso",
    SS_FOOTER_COPY_RESERVED:
      "Derechos de autor. ©2023 Todos los derechos reservados",
    SS_FOOTER_HOME: "Inicio",
    SS_FOOTER_HOW_IT_WORKS: "Cómo funciona",
    SS_FOOTER_FOR_BRANDS: "Para Marcas",
    SS_FOOTER_WHAT_NEW: "Novedades",
    SS_FOOTER_HELP_SUPPORT: "Servicio de asistencia",
    SS_FOOTER_PRIVACY_POLICY: "Política de privacidad de ARIIX",
    SS_TERMS_OF_USE: "Términos de uso",
    SS_FOOTER_SUB_FOR_UPDATES: "Suscríbete para recibir actualizaciones",
    SS_FOOTER_FOLLOW_US: "SÍGUENOS",
    SS_SUCESS: "Compartir el éxito",
    SS_REGISTER_YSSYP:
      "Has compartido correctamente tu producto. ¡Es hora de crear una cuenta para gestionar tus ganancias!",
    SS_REGISTER_BSUFAK:
      "Al registrarme en una cuenta de Kwik, acepto todos los Términos y condiciones establecidos.",
    SS_REGISTER_YAAD: "¡Ya casi has terminado!",
    SS_REGISTER_WHSAVCT:
      "Hemos enviado un código de verificación a la dirección de correo electrónico que utilizaste en el proceso de pago. Si necesitas otro código, haz clic en reenviar.",
    LEGAL_INFO: "Información legal",
    LEGAL_WELCOME_TO_KWIK: "¡Bienvenido a WeR1!",
    LEGAL_TC: "Términos y condiciones",
    HEADER_MENU_SHARING: "Compartir",
    HEADER_MENU_BUY: "Comprar",
    HEADER_MENU_SHOPPING: "Compras",
    HEADER_MENU_HELP: "Ayuda",
    HEADER_MENU_ACCOUNT_SETTING: "Ajustes de la cuenta",
    HEADER_LAYER_ACCOUNT: "CUENTA",
    HEADER_LAYER_EDIT_ACCOUNT: "Editar cuenta",
    HEADER_LAYER_LOGOUT: "Cerrar sesión",
    HEADER_LAYER_HELP_CONTACT: "Ayuda/Contacto",
    HEADER_LAYER_HELP_LEGAL: "Legal",
    HEADER_LAYER_HELP_LANGUAGE: "Idioma",
    HEADER_LAYER_HELP_SELECT_YOUR_GEOGRAPHICAL_REGION:
      "Selecciona tu región geográfica",
    HEADER_LAYER_HELP_SELECT_YOUR_PREFERRED_LANGUAGE:
      "Selecciona tu idioma preferido",
    SETTING_HEADER_ACCOUNT: "Cuenta",
    SETTING_HEADER_HELP_CONTACT: "Contacto de ayuda",
    SETTING_HEADER_LEGAL: "Legal",
    SETTING_HEADER_SETTINGS: "Ajustes",
    SETTING_ACCOUNT_CHANGE_IMAGE: "Cambiar imagen",
    SETTING_ACCOUNT_FIRST_NAME: "Nombre",
    SETTING_ACCOUNT_FIRST_NAME_IS_REQUIRED: "El nombre es obligatorio",
    SETTING_ACCOUNT_LAST_NAME: "Apellidos",
    SETTING_ACCOUNT_LAST_NAME_IS_REQUIRED: "El apellido es obligatorio",
    SETTING_ACCOUNT_USER_NAME: "Nombre de usuario",
    SETTING_ACCOUNT_USER_NAME_IS_REQUIRED:
      "El nombre de usuario es obligatorio",
    SETTING_ACCOUNT_PROFILE_CONTACT_INFO: "Información de contacto del perfil",
    SETTING_ACCOUNT_PHONE_NUMBER: "Número de teléfono",
    SETTING_ACCOUNT_PHONE_NUMBER_IS_REQUIRED:
      "El número de teléfono es obligatorio",
    SETTING_ACCOUNT_EMAIL: "Correo electrónico",
    SETTING_ACCOUNT_EMAIL_IS_REQUIRED: "El correo electrónico es obligatorio",
    SETTING_ACCOUNT_PLEASE_NOTE_MESSAGE:
      "Nota: así es como la gente podrá ponerse en contacto contigo desde tu página de perfil. Actualízalos para que la gente sepa dónde ponerse en contacto contigo.",
    SETTING_ACCOUNT_YOUR_LOGIN_EMAIL_MESSAGE:
      "Tu correo electrónico de inicio de sesión y el número de teléfono de tu cuenta seguirán siendo los mismos.",
    SETTING_ACCOUNT_SECURITY: "Seguridad",
    SETTING_ACCOUNT_PASSWORD: "Contraseña",
    SETTING_ACCOUNT_DISCARD: "Descartar",
    SETTING_ACCOUNT_CHANGE_PASSWORD: "Cambiar la contraseña",
    SETTING_CONTACT_HELP_CONTACT: "Ayuda y contacto",
    SETTING_CONTACT_CONTACT_US_AT: "Contacta con nosotros en",
    SETTING_CONTACT_ADDRESS: "Dirección",
    SETTING_CONTACT_EMAIL: "Correo electrónico",
    SETTING_CONTACT_PHONE: "Teléfono",
    SETTING_CONTACT_WHAT_TYPE_OF_PROBLEM: "Qué tipo de problema es",
    SETTING_CONTACT_PROBLEM_IS_REQUIRED: "El problema es obligatorio",
    SETTING_CONTACT_THIS_FIELD_IS_REQUIRED: "Este campo es obligatorio",
    SETTING_CONTACT_PLEASE_GIVE_US_DETAILS_MESSAGE:
      "Danos detalles sobre el asunto del que estás informando. Tu nombre, dirección de correo electrónico y número de pedido, si está relacionado.",
    SETTING_CONTACT_DETAIL_IS_REQUIRED: "El dato es obligatorio",
    SETTING_CONTACT_ATTACH_ANY_IMAGES_MESSAGE:
      "Adjunta imágenes o capturas de pantalla",
    SETTING_CONTACT_DRAG_AND_DROP_MESSAGE:
      "Arrastra y suelta un archivo de vídeo a los recursos, o explora",
    SETTING_CONTACT_SUBMIT: "Enviar",
    SORRY_YOU_CAN_T_SHARE_PRODUCT_MESSAGE:
      "Lo sentimos, no puedes compartir el producto #{{names}}. Compra este producto ahora o solicita la elegibilidad",
    USER_REGISTER_INVLID_INPUT_CHARACTERS:
      "    Caracteres de entrada no válidos",
    CHECKOUT_PAYMENT: "    Pago",
    ADD_PRODUCT_RETAIL: "    Precio minorista",
    ADD_PRODUCT_WHOLESALE: "    Precio mayorista",
    ADD_PRODUCT_PLEASE_INPUT_YOUR_WHOLESALE:
      "    Introduce tu venta al por mayor!",
    ADD_PRODUCT_RETAIL_SHOULD_NOT_MESSAGE:
      "    La venta al por mayor debe ser menor que la venta al por menor",
    ADD_PRODUCT_PROMOTIONAL_INSTANT_KWIK_CASH_ACCRUAL:
      "    Crédito promocional instantáneo KwikCash",
    ADD_PRODUCT_OF_RETAIL: "    de venta al por menor",
    ADD_PRODUCT_BRAND_PAYOUT: "    Pago de la marca (mayorista ajustado)",
    ADD_PRODUCT_KWIK_REVENUE: "    Ingresos Kwik",
    ADD_PRODUCT_OF_DELTA: "    de Delta",
    ADD_PRODUCT_ADMINISTRATION_FEE: "    Tasa de administración",
    ADD_PRODUCT_REFERRAL_FEE: "    Tasa de referencia",
    ADD_PRODUCT_INSTANT_KWIK_CASH_ACCRUAL: "    Crédito instantáneo KwikCash",
    ADD_PRODUCT_COMMISSION_ALLOCATION: "    Asignación de comisiones",
    ADD_PRODUCT_TRUE_COMMISSION_ALLOCATION: "    Asignación real de comisiones",
    ADD_PRODUCT_LEVEL_WAVE_OF_COMMISSION: "      {{level}} Onda de comisiones",
    VENDOR_SETTINGS_BRAND_ID: "    ID de marca",
    VENDOR_SETTINGS_KWIK_REVENUE: "    Ingresos Kwik(%)",
    VENDOR_SETTINGS_ADMIN_FEE: "    Tasa de administración(%)",
    VENDOR_SETTINGS_RETAIL_MULTIPLLER: "    Multiplicador minorista",
    VENDOR_SETTINGS_FEE_MULTIPLLER: "    Multiplicador de tasas",
    VENDOR_SETTINGS_REFERRAL_FEE: "    Tasa de referencia(%)",
    VENDOR_SETTINGS_IKCA: "    Crédito instantáneo de KwikCash(%)",
    VENDOR_SETTINGS_REFERRAL_EMAIL: "    Correo electrónico de la referencia",
    VENDOR_SETTINGS_TP: "    Promoción temporal(%)",
    VENDOR_SETTINGS_NEWAGE_CAMPAIGN: "    Compromiso con la marca NewAge",
    VENDOR_SETTINGS_FULL_BY_NEWAGE: "    Completado por NewAge",
    VENDOR_SETTINGS_CTPV: "    Porcentaje de comisión sobre el valor PV(%)",
    VENDOR_SETTINGS_DPP: "    Dólar por PV",
    PRODUCTS_DETAIL_VENFOR_PAYOUT: "    Pago del proveedor",
    PRODUCTS_DETAIL_PAYOUT_REMITTENCE: "    Remesa de pagos",
    PRODUCTS_DETAIL_CASHBACK_STRUCTRUE:
      "    Estructura de devolución de dinero",
    PRODUCTS_DETAIL_CASHBACK: "    Devolución de dinero",
    PRODUCTS_DETAIL_PROMOTIONAL_CASHBACK:
      "    Devolución de dinero promocional",
    PRODUCTS_DETAIL_WAVE_COMM_STRUCTURE:
      "    Estructura de comisiones de la onda",
    PRODUCTS_DETAIL_WAVE_COMM_STRUCTURE_DESC:
      "    Determinado por Precio minorista - Precio mayorista. Ajustarlos para ver cambios en la estructura de la onda",
    PRODUCTS_DETAIL_TOTAL_WAVE_FUNDING: "    Financiación total de la onda",
    PRODUCTS_DETAIL_1ST_OF_RETAIL: "    1.ª onda como % de la venta minorista",
    PRODUCTS_DETAIL_TEMPORARY_PROMOTIONS: "    Promociones temporales",
    PRODUCTS_DETAIL_OPTIONAL: "    Opcional",
    PRODUCTS_DETAIL_TPR: "    Temporal - Remesa de pagos",
    PRODUCTS_DETAIL_SALES_CHANNEL: "    Canal de ventas",
    PRODUCTS_DETAIL_SALES_CHANNEL_DESC:
      "    Ten en cuenta que estos canales adicionales son opcionales. Si optas por uno de ellos puede repercutir en los importes de las distintas ondas.",
    PRODUCTS_DETAIL_DIRECT_DISTRIBUTE: "    Distribución directa",
    VENDOR_SETTINGS_WRONG_TYPE: "    Introduce el tipo de número",
    PRODUCTS_DETAIL_TAX_VAT_DUTY: "    Impuestos/IVA/Derechos",
    PRODUCTS_DETAIL_REQUIRE_EU: "    - Obligatorio para los países de la UE",
    PRODUCTS_DETAIL_REQUIRE_AUS: "    - Obligatorio para Australia",
    PRODUCTS_DETAIL_REQUIRE_CAN:
      "    - Obligatorio para el comercio electrónico transfronterizo a Canadá",
    SHARE_LINK_PRICE_VAT: "    IVA",
    LEGAL_CONTENT:
      '¡Le damos la bienvenida a Kwik!\nKwik es un mercado único donde puede vender, comprar, compartir y ganar a través de su influencia en línea. Queremos que todos los que visiten nuestra página y utilicen nuestros productos tengan una buena experiencia. Nuestros productos incluyen nuestra página web, nuestra aplicación móvil, etc.\nEste es un contrato legalmente vinculante entre usted y Kwik. Al utilizar los productos de Kwik, acepta los siguientes Términos y condiciones que constituyen nuestras reglas para ayudar a todos a tener la mejor experiencia posible. Si no está de acuerdo con estos términos, no utilice los productos de Kwik.\nTenga en cuenta que estos Términos y condiciones no crean ninguna relación de asociación, empresa conjunta, empleo o franquicia entre usted y Kwik.\nSi está interesado en vender a través de Kwik, también debe entender y aceptar nuestra Política de vendedores\nSu cuenta\nPara utilizar nuestros productos, deberá crear una cuenta. Haga clic aquí para saber cómo crear una cuenta en Kwik. Al crear una cuenta, acepta los siguientes términos:\nSolo debe haber una cuenta por persona; usted es responsable de su propia cuenta\nDebe tener 18 años o más. Los jóvenes mayores de 13 años pueden utilizar Kwik solo a través de la cuenta de un progenitor o tutor legal. Cualquier uso de los servicios por parte de un menor en su cuenta es su responsabilidad. Los menores de 13 años no pueden utilizar nuestros productos.\nLa información que proporcione sobre su persona debe ser honesta y precisa. Está prohibido hacerse pasar por otra persona o empresa en su cuenta.\nUsted es responsable de garantizar la seguridad de su cuenta y de proteger su contraseña.\nUso de los productos Kwik\nAl utilizar los productos Kwik, afirma que entiende y acepta los siguientes términos. Cuando utilice Kwik:\nNo acceda a los datos de los productos Kwik utilizando robots, arañas o cualquier forma automatizada para la que no tenga permiso de acceso\nNo recopile, copie, utilice, transfiera o venda ningún dato de los productos Kwik que no le haya sido proporcionado por Kwik\nNo cargue un enlace no autorizado a una página externa\nNo cargue o ayude a cargar la introducción de cualquier código malicioso o virus en los productos Kwik\nNo haga nada que infrinja derechos de terceros, incluyendo los derechos de propiedad intelectual\nNo perjudique el correcto funcionamiento de los productos Kwik\nNo infrinja las leyes locales o internacionales, las marcas, los derechos o los derechos de propiedad intelectual \nSiga nuestra política de marcas comerciales\nPague todas las cuotas que se deban a Kwik\nContenido\nAl utilizar Kwik, usted tendrá varias oportunidades de crear contenido. El contenido que puede producir incluye (pero no se limita a) reseñas, comentarios, fotos, imágenes de perfil, descripciones en su perfil y mensajes a los vendedores. Usted es responsable del contenido que se publique o cargue en su cuenta.\nPara asegurar una buena experiencia para todos los miembros de Kwik, existen determinados tipos de contenido que no queremos que se publiquen en los productos de Kwik. Al utilizar nuestros productos, se compromete a no producir contenidos que inciten al odio, sean abusivos, amenazantes, vulgares, obscenos, falsos, engañosos o que induzcan a error de cualquier manera. \nKwik se compromete a proteger los derechos de propiedad intelectual. Si sube o publica contenido que infrinja la propiedad intelectual de otro, tomaremos las medidas oportunas. Esto puede incluir la desactivación temporal de su cuenta o la cancelación si utiliza o infringe repetidamente la propiedad intelectual de otros. En caso de que esto ocurra, se lo notificaremos. Póngase en contacto con Kwik si algún contenido que le pertenece o sobre el que tiene derechos ha resultado publicado sin su permiso.\nSi es un vendedor, consulte nuestra política de vendedores para obtener más información sobre nuestras normas.\nSu privacidad\nNos comprometemos a proteger su privacidad y su información personal. A continuación se describe qué información personal recopila Kwik y cómo se utiliza. Si no desea que Kwik utilice su información de las formas descritas a continuación, no utilice los productos Kwik.\nKwik puede obtener la información que usted proporcione voluntariamente. Para utilizar los productos Kwik y crear una cuenta, debe proporcionar una dirección de correo electrónico válida y un nombre que será asociado a su cuenta. Puede optar por proporcionar otra información en su cuenta, como la fecha de nacimiento, la biografía, la ubicación o el género. También puede dejar reseñas sobre productos u otros comentarios. Esta información estará disponible para otros visitantes y miembros de Kwik.\nSi gana distribuciones de ondas (o Kwik Cash) deberá proporcionar más datos financieros (por ejemplo, números de cuenta y de tarjeta de crédito, detalles de la transacción y forma de pago). Si tiene intención de vender a través de Kwik, consulte nuestra Política de vendedores para conocer la información que debe proporcionar a Kwik para verificar su identidad e información financiera para que pueda beneficiarse de sus ventas.\nCuando usted publica contenido a través de los productos de Kwik, concede a Kwik una licencia para utilizarlo. Nunca reclamamos el contenido como propio. Utilizamos y compartimos el contenido publicado por los vendedores para promocionar los productos de los vendedores a otros vendedores y compradores en función de sus listados, búsquedas y uso de los productos Kwik. Este permiso también permite a Kwik realizar ciertos ajustes en el contenido, como mejorar o cambiar el tamaño de una foto o traducir el contenido a un idioma diferente según sea necesario.\nKwik también recopila automáticamente información cuando usted utiliza nuestros productos, incluyendo nuestra página y app móvil. Esto puede incluir su dirección IP, otro identificador de dispositivo único o la versión de la aplicación móvil que está utilizando. Esta información puede ayudarnos a prevenir el fraude entre los usuarios. Kwik también recopilará automáticamente datos sobre su uso del sitio, como las páginas que visita y cómo interactúa con esas páginas (como hacer clic en un enlace o la duración del tiempo en una página). Esto nos ayuda a personalizar su experiencia y a facilitar la publicidad basada en sus intereses.\nTanto Kwik como los vendedores recopilan información personal del comprador y ambos son controladores de datos. Cuando compra un artículo a través de Kwik, también proporciona información a los vendedores, que puede incluir su nombre, dirección, dirección de facturación e información de pago. Los vendedores deben respetar las normas de protección de la privacidad del comprador, tal y como se indica en nuestra Política de vendedores. Durante el proceso de compra, podemos almacenar la información de la tarjeta de crédito, la dirección de facturación y otros datos para procesar su transacción y para la facturación y el pago. Los miembros de algunos países pueden elegir que Kwik recuerde su información para facilitar futuras compras.\nOtra información que obtenemos es la que proporciona cuando se pone en contacto con el servicio de atención al cliente. \nGanar Kwik Cash\nLos influencers pueden ganar Kwik Cash cuando compran un producto, comparten un enlace único a ese producto en a través de las redes sociales, se hace clic en ese enlace para visitar la página del producto y se realiza una venta. El influencer DEBE comprar el producto y la venta debe realizarse utilizando el enlace del influencer para que este gane Kwik Cash. Como se ha indicado anteriormente, tendrá que presentar información adicional, incluida la información financiera, para recibir su Kwik Cash.\nEn Estados Unidos, donde opera Kwik, los influencers deben cumplir con las normas de divulgación de la conexión material de la Comisión Federal de Comercio (FTC) [enlace]. Esto es necesario cuando la conexión material (como un pago, un producto o servicio gratuito, o un patrocinio) afectaría a la credibilidad del respaldo del influencer (por ejemplo, solo sería positivo porque el influencer se beneficia) o cuando la audiencia no lo esperaría porque no hay una conexión obvia con la marca.\nPara ganar Kwik Cash, los influencers deben cumplir las siguientes reglas:\nEl influencer debe revelar claramente que existe una conexión material con los productos, bienes o servicios de un vendedor. Presentamos algunos ejemplos sobre cómo puede revelarlo:\nRevelación: al hacer clic en este enlace y comprar [producto de la marca] en Kwik, me beneficio ganando Kwik Cash.\nHashtags claramente visibles como #anuncio, #patrocinado, #publicidad de [marca] o #anuncio\nLa divulgación debe estar dentro del post del influencer sobre el producto y ser claramente visible.\nEl influencer debe ser honesto y no engañar sobre el producto.\nEl influencer no puede hacer afirmaciones falsas sobre el producto, incluyendo falsedades absolutas, testimonios no representativos (como un efecto de un producto que no se aplicaría a todos, por ejemplo, "esta crema facial me hizo parecer cinco años más joven"), o afirmaciones sin fundamento (el influencer no tiene la experiencia adecuada con el producto para avalarlo).\nSi se encuentra fuera de Estados Unidos, pueden aplicarse leyes similares. Los residentes en Canadá deben conocer la ley de la competencia [enlace] de la Oficina de Competencia y sus sanciones por infringir la normativa sobre influencers. Si se encuentra en el Reino Unido, deberá conocer la normativa sobre influencers en las redes sociales publicada por la Autoridad de Normas de Publicidad (ASA), el Comité de Prácticas Publicitarias (CAP) y la Autoridad de Competencia y Mercados (CMA). [enlaces] Usted es responsable de conocer las leyes de su país de residencia y de utilizar su influencia en las redes sociales en consecuencia.\nPolítica de exclusión 401(k)\nCuando gana Kwik Cash, entiende que Kwik no tiene ni es responsable de ofrecerle un plan 401(k) ya que no es un empleado de Kwik.\nPolítica de disputas\nPolítica de casos \nSi tiene un problema con un producto, le pedimos que primero se ponga en contacto con el vendedor directamente para resolver ese problema. Si el vendedor no responde o no resuelve el problema, puede abrir un caso con Kwik. \nSe puede abrir un caso si el artículo llega y no es como se describe o se muestra en la tienda del vendedor o si no se entrega debido a las acciones del vendedor. El comprador debe proporcionar una foto para un artículo que se reclama que no es como se describe o como se muestra en la tienda del vendedor. Algunos ejemplos podrían ser un artículo que esté \nhecho de un material o patrón diferente al descrito,\nuna talla, color, modelo o versión diferente, un\nestado diferente al descrito (es decir, se describe como nuevo pero está usado),\nuna cantidad incorrecta de artículos,\nun artículo dañado, \npiezas o partes ausentes o\nservicios incompletos\nEl vendedor debe enviar un artículo comprado dentro de un plazo razonable o para cumplir con una fecha de entrega prometida. Sin embargo, no se puede abrir un caso si el artículo está dañado, no se ha entregado o se ha entregado con retraso debido al envío de terceros, ya que ni el vendedor ni Kwik tienen la culpa. \nLos casos se resolverán cuando\nEl comprador reciba un reembolso.\nEl comprador cierre el caso.\nSi el caso estaba abierto porque la entrega no se realizó y el vendedor aporta pruebas de que el artículo se envió a tiempo a la dirección del comprador.\nPara más información sobre las responsabilidades del vendedor, consulte nuestra política de vendedores.\nDisputas con terceros\nCuando surja un problema relacionado con un producto o una interacción con un vendedor u otro miembro de Kwik, siga los pasos indicados anteriormente en nuestra Política de casos. Haremos todo lo posible para ayudarle a resolver cualquier problema relacionado con nuestras políticas. Sin embargo, no estamos obligados a resolver las disputas que usted tenga con otros miembros de Kwik o con un tercero. Usted exime a Kwik de cualquier reclamación, daño o demanda que surja de las disputas con otros miembros o partes. \nDisputas con Kwik\nTanto si es un vendedor como un comprador, si tiene una disputa con nosotros, póngase en contacto con nosotros primero y haremos todo lo posible para resolver el problema. Si las disputas no se pueden resolver a través de nuestro servicio de atención al cliente, le invitamos a consultar nuestras políticas para proceder a continuación.\nDerecho aplicable\nEstos Términos y condiciones se rigen por las leyes de Estados Unidos. Si usted vive fuera de Estados Unidos, puede estar protegido por las leyes de protección al consumidor obligatorias de su ley local de protección al consumidor.\nSi tiene algún problema con nosotros, le rogamos que se ponga en contacto con nosotros y trabajaremos para resolver el problema. Sin embargo, si el asunto no se puede resolver, las siguientes reglas regirán cualquier disputa legal relacionada con Kwik y sus Productos.\nIntermediación\nAl utilizar nuestros servicios, acepta resolver todas las disputas con Kwik a través de una intermediación individual vinculante. Esto significa que las disputas las gestiona un intermediario y no están supeditadas a la decisión de un juez o un jurado. Usted renuncia a cualquier derecho a participar en demandas colectivas, intermediaciones colectivas o acciones representativas. (Las intermediaciones colectivas solo serán posibles si lo solicita cualquiera de las partes de acuerdo con su Reglamento de intermediación en acciones colectivas y lo aprueba el intermediario). La intermediación la gestionará la Asociación Americana de Arbitraje, o la "AAA", en virtud de sus Normas de arbitraje comercial, o las "Normas de la AAA", entonces vigentes, a menos que la ley exija lo contrario. Cada una de las partes tiene derecho a presentar una acción ante un tribunal que tenga la jurisdicción adecuada después de la decisión final del intermediación o del mediador.\nEn lugar de una intermediación, también puede hacer valer sus reclamaciones en un tribunal de menor rango si su caso reúne las condiciones necesarias. Su caso también debe avanzar únicamente de forma individual (no colectiva ni representativa). La Ley Federal de Arbitraje ("FAA") y las leyes vigentes determinarán la interpretación y el cumplimiento de estos Términos y condiciones. \nLas Normas de arbitraje comercial de la AAA determinarán los pagos por cualquier presentación razonable de la AAA, incluyendo los honorarios administrativos y del intermediador. Si el valor de su reclamación no supera los 10 000 USD, Kwik pagará los honorarios de presentación, administrativos y del intermediador relacionados con la intermediación. Sin embargo, si el intermediador determina que su reclamación o la subsanación solicitada no es seria o se presenta con un propósito inapropiado, Kwik no será responsable del pago. \nLimitación de responsabilidad\nAl utilizar los productos de Kwik, acepta no responsabilizar a Kwik por: \nArtículos comprados y uso de artículos \nCuando compra un artículo de los productos de Kwik, reconoce que no está comprando un artículo de Kwik. Los artículos que se publican y venden a través de los productos de Kwik son de vendedores independientes. Si tiene un problema con el artículo, póngase en contacto con el vendedor o abra un caso con Kwik como se ha descrito anteriormente. \nKwik no se hace responsable de las consecuencias que se deriven del uso del artículo. Si el uso o el uso inadecuado de un artículo provoca daños personales o daños al artículo, usted se compromete a no responsabilizar a Kwik.\nPáginas web o servicios de terceros\nEl contenido de los vendedores y miembros de Kwik puede incluir enlaces a páginas web de terceros, servicios, páginas de redes sociales u otros mercados en línea. Usted entiende que estos no se encuentran bajo el control o la influencia de Kwik. Muchas de estas páginas web y servicios tendrán sus propios Términos y condiciones que acepta cumplir, y es su responsabilidad estar al tanto. Del mismo modo, accede a los productos de Kwik utilizando un dispositivo como un teléfono móvil, y estos tampoco están asociados a Kwik.\nContenido e interacción con los miembros\nComo miembro de Kwik, puede compartir contenido a través de su perfil, dejando una reseña o enviando un mensaje. Nos preocupamos porque disfrute de su experiencia, por lo que pedimos a todos los miembros de Kwik que se atengan a nuestras normas. Sin embargo, cualquier contenido publicado por un miembro no refleja a Kwik y no nos hacemos cargo de ningún contenido publicado. Kwik no es responsable de la legalidad, la exactitud, el cumplimiento de los derechos de autor o el cumplimiento de nuestras normas de cualquier contenido publicado por los miembros a los que accede a través de nuestros productos. Usted libera a Kwik de toda responsabilidad relacionada con el contenido de los miembros.\n Kwik tampoco es responsable de su interacción con otros individuos a través de Kwik. Aunque los miembros pueden abrir casos en respuesta a productos dañados o no entregados, y Kwik terminará una cuenta cuando se infrinjan ciertas reglas (ver más abajo), entienda que no examinamos a los usuarios de nuestros productos. Usted exime a Kwik de toda responsabilidad relacionada con sus interacciones con otros usuarios. Le invitamos a utilizar el buen juicio y la precaución en todas sus interacciones con otros en Kwik o en cualquier servicio. Por ejemplo, no siempre es una buena idea acordar un encuentro en persona con alguien que ha conocido en línea.\nIndemnización \nEn el improbable caso de que Kwik reciba una demanda debido a sus acciones, al uso o mal uso de nuestros productos, al incumplimiento de estos Términos o condiciones, o a la infracción de los derechos de otra persona, usted acepta indemnizar a Kwik. Esto significa que nos defenderá o nos eximirá de responsabilidad (incluyendo a los empleados, afiliados y subsidiarios) de cualquier reclamación o demanda legal, incluyendo los honorarios legales. \nNos reservamos el derecho de gestionar nuestra defensa legal como creamos conveniente. Esto incluye cuando usted nos indemniza, en cuyo caso se compromete a cooperar con nosotros.\nCambios en las condiciones de uso \nLe notificaremos cualquier cambio sustancial en nuestros Términos y condiciones 30 días antes de que entre en vigor. Al continuar utilizando los productos de Kwik, acepta todas las actualizaciones. Si no está de acuerdo con cualquier cambio en nuestras condiciones, puede enviar a Kwik una notificación por escrito o cancelar su cuenta antes de que los cambios entren en vigor.\nDisputas sobre los cambios\nAl igual que con todos los cambios y modificaciones de nuestras condiciones, se le notificará y podrá optar por aceptar los cambios o rechazarlos dando de baja su cuenta. Si rechaza los términos actualizados y tiene una disputa con Kwik, acepta el arbitraje de la disputa de acuerdo con nuestra Política de disputas, incluyendo cualquier cambio realizado antes del rechazo. Si realizamos cualquier modificación a la Política de disputas después de la fecha en que aceptó por última vez los términos, incluyendo el uso continuo de nuestros productos después de que se le haya notificado de los cambios, esas modificaciones no se aplicarán a cualquier reclamación presentada en un procedimiento legal contra Kwik antes de la fecha en que los cambios se hicieron efectivos. Si cancela su cuenta y luego la vuelve a abrir, acepta la versión actual de estos Términos y condiciones.\nCancelación de su cuenta\nLa cancelación de su cuenta puede ocurrir de dos maneras: por su parte o por la nuestra. Puede cancelar su cuenta en cualquier momento a través de la configuración de su cuenta. Si cancela su cuenta, el contenido que haya creado y publicado (como comentarios, reseñas o fotos subidas) permanecerá en los productos de Kwik. Tenga en cuenta que puede perder otra información asociada a su cuenta.\nPodemos suspender o cancelar su cuenta si tenemos razones para creer que ha infringido estos Términos y condiciones utilizando los productos de Kwik. Si lo hacemos, no tiene ningún derecho legal o contractual a seguir utilizando nuestros productos. Por ejemplo, después de que su cuenta se cancele, no podrá comprar o vender a través de nuestro mercado en línea. A menos que haya infringido nuestros Términos repetidamente o tengamos razones legales o políticas para no hacerlo, le notificaremos cualquier cambio en su cuenta.\nKwik se reserva el derecho de interrumpir, suspender o cambiar sus productos y la forma en que interactúa con ellos. Al utilizar nuestros productos, entiende que Kwik no es responsable del efecto de cualquier cambio o interrupción de nuestros productos. \nEstos Términos y condiciones permanecen en vigor después de que su cuenta se cancele.\nOtros asuntos legales \nEstos Términos y condiciones sustituyen cualquier otro acuerdo que usted pueda tener con Kwik. Si alguna parte de las condiciones no se puede aplicar, esa parte se limitará al mínimo necesario, y las condiciones seguirán siendo plenamente efectivas de cualquier otro modo. Si no hacemos cumplir inmediatamente cualquier parte de estas Condiciones, reconoce que nos reservamos el derecho de hacer cumplir posteriormente esa o cualquier parte de las mismas.\nPreguntas sobre los Términos y condiciones\nSi tiene alguna pregunta sobre estos Términos y condiciones, póngase en contacto con el servicio de atención al cliente en support@wer1.com.',
    SHARELINK_PRODUCT_DETAIL_NO_DATA:
      "¡Este producto no está disponible en tu país!",
    VENDOR_SHIPPING_COST_SHIPPING_METHODS: "Método de envío",
    CHECKOUT_SAVE_SHIPPING_ADDRESS_MESSAGE: "Rellena el siguiente formulario",
    SORRY_YOUR_PAYMENT_DID_NOT_GO_THROUGH:
      "No hemos podido procesar tu pago. Por favor, inténtelo de nuevo.",
    ORDER_HISTORY_ORDER_MORE: "Pedir más",
    ORDER_HISTORY_SHARE_PRODUCT: "Compartir producto",
    ORDER_HISTORY_EDIT_REVIEW: "Editar reseña",
    ORDER_HISTORY_ADD_REVIEW: "Escribir reseña",
    ORDER_HISTORY_SHIPPING_DETAIL: "Detalles de envío",
    ORDER_HISTORY_ARRIVAL_DATE: "Fecha de llegada",
    ORDER_HISTORY_TRACKING_NUMBER: "Número de seguimiento",
    ORDER_HISTORY_ORDER_INFO: "Información del pedido",
    ORDER_HISTORY_TOTAL_COST: "Coste total",
    ORDER_HISTORY_ORDER_DATE: "Fecha de orden",
    ORDER_HISTORY_SHIP_DATE: "Fecha de envío",
    ORDER_HISTORY_SHIP_LOCATION: "Ubicación del barco",
    CHECKOUT_PRE_VAT_SUBTOTAL: "Subtotal antes de IVA",
    CHECKOUT_VAT_TOTAL: "Total IVA",
    CHECKOUT_PRE_VAT_SHIPPING: "Envío antes de IVA",
    CHECKOUT_SHIPPING_VAT: "IVA de envío",
    CHECKOUT_ORDER_TOTAL: "Total pedido",
    CHECKOUT_ORDER_INFORMATION_ERROR_MESSAGE:
      "Error en la información del pedido, ponte en contacto con el servicio de atención al cliente.",
    SHARING_MFSP: "Productos más compartidos",
    SHARING_KWIK: "Kwik",
    SHARING_ESS: "Explorar, comprar, compartir",
    SHARING_FYNCTEM: "Encuentra tu próxima campaña para ganar más",
    ACCOUNT_PHONE_UNIQUE:
      "Este número de teléfono ya está asociado con una cuenta de Kwik. Introduce un nuevo número de teléfono",
    CHECKOUT_ADDRESS_INVALID_FORMAT: "Formato no válido",
    VENDOR_INVENTORY_PLEASE_SELECT_WAREHOUSE: "Selecciona almacén",
    VENDOR_INVENTORY_ADD_INVENTORY_FOR_SKU: "Añadir inventario para N.º SKU",
    ORDER_HISTORY_VIEW_DETAILS: "Ver detalles",
    VENDOR_INVENTORY_EDIT_INVENTORY: "Editar inventario",
    SHARING_NEW_TITLE: "Bienvenido/a a WeR1",
    VENDOR_PRODUCT_PSTCAW: "¡Selecciona el país y almacén!",
    VENDOR_PRODUCT_PSDCAW: "¡Selecciona otro país y almacén!",
    VENDOR_INVENTORY_ENTER_A_POSITIVE_OR_NEGATIVE_MESSAGE:
      "Introduce un número positivo o negativo para sumar o restar a la cantidad asignada.",
    VENDOR_INVENTORY_INVALID_VALUE: "¿Valor no válido?",
    PRODUCT_DETAIL_UPPER_LIMIT_OF_THE_INVENTORY:
      "Límite superior del inventario",
    PRODUCTS_COPY_BUTTON: "Copiar",
    PRODUCT_DETAIL_BACK_TO_PRODUCT_LIST: "Volver al listado de productos",
    NEW_PRODUCT_ID: "ID del nuevo producto",
    NEW_PRODUCT_NAME: "Nombre del nuevo producto",
    SHARING_TOP_DESC1: "Compra, comparte, gana con Kwik!",
    SHARING_TOP_DESC2_1: "Completa la",
    SHARING_TOP_DESC2_2: "Guía de introducción",
    SHARING_TOP_DESC2_3: "a continuación",
    SHARING_TOP_DESC3_1: "para ganar",
    SHARING_TOP_DESC3_2: "5 $ KwikCash!",
    SHARING_CHECKBOX_1: "Crear una cuenta Kwik",
    SHARING_CHECKBOX_2: "Únase a una campaña",
    SHARING_CHECKBOX_3: "Comparte tu enlace",
    SHARING_CHECKBOX_4: "Ver tu KwikCash",
    SHARING_CHECKBOX_5: "Revisa tus olas",
    SHARING_ALL_PRODUCT: "Compartir todos los productos",
    KWIKCASH_ADD_PAYPAL: "Añadir PayPal",
    ERC__CLICKING_CONFIRM_MESSAGE:
      'Acepto los <a href="https://cms.kwik.com/Terms%26ConditionsWeR1.pdf" target=""_blank""><span>Términos</span></a> y <a href="https://cms.kwik.com/PrivacyPolicyWeR1.pdf.pdf" target=""_blank""><span>la Política de privacidad de WeR1</span></a>',
    KWIKCASH_CONNECT_TO_PAYPAL: "Conectar con Paypal",
    KWIKCASH_PLEASE_INPUT_THE_AMOUNT: "¡Introduce el importe!",
    ENTER_LOGIN_EMAIL:
      "Introduce tu correo electrónico para empezar o inicia sesión",
    I_FORGOT_PASSWORD: "He olvidado mi contraseña",
    KWIKCASH_THE_ACCOUNT_NUMBER_SHOULD_BE_EMAIL_ADDRESS:
      "El número de cuenta debe ser la dirección de correo electrónico",
    REGISTER_WE_JUST_SEND_YOU_A_VERIFY_MESSAGE:
      "Acabamos de enviarte un código de verificación. Revisa tus carpetas de spam y promociones.",
    REGISTER_RESEND_CODE: "Reenviar código",
    REGISTER_CREATE_ACCOUNT: "Crear cuenta",
    REGISTER_DONT_RECEIVED: "¿No lo has recibido?",
    REGISTER_SIGN_IN: "Iniciar sesión",
    REGISTER_ALREADY_A_MEMBER: "¿Ya eres miembro?",
    YOUR_EMAIL: "Tu correo electrónico",
    LET_FIND_LINK: "¡Vamos a encontrar tu enlace!",
    ENTER_EMAIL_FIND_LINK:
      "Introduce tu correo electrónico y podremos ver si tienes un enlace",
    ENTER_LOGIN_CRED: "Introduce tus credenciales para continuar",
    SHARING_TOP_DESC2_NEW:
      "Para ayudarte a empezar, hemos creado una Lista de Comprobación para Principiantes",
    SHARING_TOP_DESC3_NEW:
      "Haz clic AQUÍ para obtener más información sobre Kwik.",
    SHARING_NO_LINK_TO_SHARE: "¿No hay enlaces para compartir?",
    SHARING_ITEM_TEXT_1: "Explora el marketplace de Kwik",
    SHARING_ITEM_TEXT_2: "Compra un producto de una marca que te guste",
    SHARING_ITEM_TEXT_3: "Compartir un enlace de producto",
    SHARING_ITEM_TEXT_4: "Ganar KwikCash",
    YOU_MAY_ALSO_LIKE: "También te puede interesar",
    ADD_REVIEW: "Añadir una reseña",
    BE_FIRST_REVIEW: "Sé el primero en opinar",
    COMMENT: "Comentario",
    REFERRAL_MESSAGE: "Mensaje de referencia",
    VERIFIED_PURCHASER: "Comprador verificado",
    COMMENTS: "Comentarios",
    COPY_FROM_PROD: "Copiar del producto",
    COPY_TO_PROD: "Copiar a producto(s)",
    KWIKCASH_PAYPAL_EMAIL_ADDRESS: "Dirección de correo electrónico",
    SHARELINK_PRODUCT_DETAIL_CASHBACK_ON_PURCHASE: "de reembolso en la compra",
    SHARE: "Compartir",
    CASHBACK_ON_PURCHASE: "de reembolso en la compra",
    EMAIL_NOT_REGISTERED: "Este correo electrónico no está registrado",
    SEND_SUCCESS: "Enviar correctamente",
    LOGIN_KIHTM: "WeR1 está aquí para hacer",
    LOGIN_ERE: "que las recomendaciones cotidianas sean más fáciles",
    PROCEED: "Continuar",
    TSIPBRATGPP:
      "Este sitio está protegido por reCAPTCHA y la Política de privacidad de Google",
    BRAND_NEW_TO_KWIK: "Estreno en WeR1",
    CLICK_HERE_TO_CREATE: "Haz clic aquí para crear",
    LOOKING_TO_FIND_YOUR_LINK: "Buscando para encontrar tu enlace",
    CLICK_HERE_TO_FIND_IT: "Haz clic aquí para encontrarlo",
    SHARE_INFO_LAYER_CREATE_A_SHARE_LINK: "Crear un enlace para compartir",
    SHARE_INFO_LAYER_GIVE_A_RATING: "Poner una calificación (opcional)",
    SHARE_INFO_LAYER_ADD_A_MESSAGE: "Añadir un mensaje (opcional)",
    SHARE_INFO_LAYER_250_WORDS_LEFT: "Quedan {{count}} palabras",
    SHARE_INFO_LAYER_ADD_ADDITIONAL_MEDIA: "Añadir medios adicionales",
    SHARE_INFO_LAYER_UPLOAD: "Subir",
    SHARE_INFO_LAYER_SHARE_YOUR_LINK: "Comparte tu enlace",
    SHARE_INFO_LAYER_COPY_LINK: "Copiar enlace",
    SHARE_INFO_LAYER_THE_MAXIMUM_FILE_SIZE:
      "El tamaño máximo de los archivos es de 80 MB",
    SHARE_INFO_LAYER_THE_FILE_FORMAT_IS_INCORRECT:
      "El formato del archivo es incorrecto",
    SHARE_INFO_LAYER_VERIFIED_PURCHASER: "Comprador verificado",
    SHARE_INFO_LAYER_SUPER_AMAZING_PRODUCT: "¡PRODUCTO SUPERINCREÍBLE!",
    USER_HAS_GOT_PASSWORD: "¡El usuario ya tiene contraseña!",
    INVALID_EMAIL: "Dirección de correo electrónico no válida",
    HEY_WE_MISS_YOU: "¡Oye {{name}},",
    HEY_WE_MISS_YOU2: "Nosotros te extrañamos",
    LAST_REMEMBER_YOU: "Lo último que recordamos de ti",
    SAVE_YOUR_INFO_TEXT:
      "esperábamos que volvieras, así que decidimos guardar tu información.",
    PHONE_HAS_REGISTERED: "El teléfono ha sido registrado",
    IMPACT_OF_YOUR_RECOMMENDATIONS_1: "Comprueba el verdadero impacto de tus",
    IMPACT_OF_YOUR_RECOMMENDATIONS_2: "recomendaciones.",
    FULL_NAME_NOT_BE_EMPTY: "Nombre completo no debe estar vacío",
    CODE_VERIFICATION: "Verificación de código",
    ENTER_4_DIGIT_TIPS:
      "Introduce el código de 4 dígitos que se te ha enviado a",
    CHECK_JUNK_EMAIL_FOLDER:
      "Si no encuentras fácilmente un correo electrónico de KwikClick, revisa tu carpeta de correo no deseado o spam. Si utilizas Gmail, consulta la pestaña Promociones.",
    PRODUCT_DETAIL_PAGE_CASHBACK_IS_THE_AMOUNT_MESSAGE:
      "Cashback es el importe que ganarás al instante al comprar este producto.  Estará disponible una vez finalizado el periodo de devolución.",
    LINK_HEADER_ALREADY_A_USER: "¿Ya eres usuario?",
    RESET_PASSWORD_PASS_RECOVERY: "Recuperación de contraseña",
    RESET_PASSWORD_ENTER_EMAIL_TIPS:
      "Introduce el correo electrónico que utilizas para WeR1",
    RESET_PASSWORD_SEND_TITLE: "Restablecer tu contraseña",
    RESET_PASSWORD_SEND_TIPS_1: "Hemos enviado instrucciones a: ",
    RESET_PASSWORD_SEND_TIPS_2:
      "si no has recibido el correo electrónico, pide que te vuelvan a enviar las instrucciones.",
    RESET_PASSWORD_SEND_BTN_BACK_SIGN_IN: "Volver a Iniciar sesión",
    RESET_PASSWORD_SEND_LINK_RESEND: "Reenviar instrucciones",
    RESET_PASSWORD_UPDATE_TIPS_SAME_PASS:
      "La contraseña no coincide con la contraseña de confirmación",
    RESET_PASSWORD_UPDATE_TIPS_CONFIRM: "Confirmar nueva contraseña",
    RESET_PASSWORD_UPDATE_SAVE_PASS: "Guardar contraseña",
    RESET_PASSWORD_SUCCESS_TIPS:
      "Tu contraseña ha sido creada.  Vuelve a la pantalla de inicio de sesión.",
    RESET_PASSWORD_SUCCESS_LOGIN_ACCOUNT: "Inicia sesión en Tu cuenta",
    RESET_PASSWORD_SUCCESS_BACK_HOME: "Volver a Página de inicio",
    RESET_PASSWORD_REQUIRED_EMAIL: "El correo electrónico es obligatorio",
    RESET_PASSWORD_RESEND_SUCCESS: "Reenviar éxito",
    RESET_PASSWORD_CHOOSE_PASSWORD: "Elige tu nueva contraseña",
    ALL_TIME: "Todo el tiempo",
    LAST_DAY: "Últimos {{day}} días",
    MY_CAMPAIGNS: "Mis campañas",
    SHOW_MORE: "Mostrar más",
    SHOW_LESS: "Mostrar menos",
    OTHER_PRODUCTS: "Otros productos",
    CLICK_PRODUCT_SHOW: "¡Haz clic en un producto para ver sus datos!",
    SEARCH_PRODUCT: "Buscar un producto",
    SHOWING_PAGE: "Mostrando{{pagination}}",
    REFERRAL: "{{referral}} Referencias",
    PREVIOUS: "Anterior",
    NEXT: "Siguiente",
    CASH: "Dinero",
    LEARN_KWIK: "Aprende Kwik",
    KWIK_TIPS: "Consejos Kwik",
    WANT_LEARN_ABOUT: "¿Quieres saber qué datos proporciona Kwik?",
    TOTAL_REFERRAL: "Total de referencias generadas",
    DIRECT_REFERRAL: "Referencias directas",
    WAVE_DEPTH: "Profundidad de onda",
    RECENT_ADDITIONS: "Añadidos recientemente",
    TRANSACTIONS: "Ondas",
    TOP_SHARED_PRODUCT: "Top {{count}}productos compartidos",
    VIEW_ALL: "Ver todo",
    TOP_COUNTRIES: "Top países",
    ANALYTICS: "Analytics",
    PEOPLE_REACHED: "Personas alcanzadas",
    SHARES: "Veces compartido",
    LINK_CLICKS: "Clics de enlaces",
    RECENT_SHARES: "Veces compartido recientemente",
    DATE: "Fecha",
    PLATFORM: "Plataforma",
    OPENED: "Opiniones",
    CONVERTED: "Convertido",
    SIGNED_UP: "Registrado",
    CLAIMS: "Reclamos",
    ORDERED: "Ordenada",
    WAVE_SOURCES: "Fuentes de ondas",
    REFERRAL_SUCCESS_RATE: "Tasa de éxito de referencias",
    OPEN_RATE: "Tasa de apertura",
    CONVERSION: "Conversión",
    IMPACT_RECOMMENDATIONS: "Recomendaciones con mayor impacto",
    REFFERED_BRANDS: "Marcas referenciadas",
    REFERRED_BRANDS_DESCRIPTION:
      "Estas son las marcas que has referenciado a Kwik",
    SEARCH_BRAND: "Buscar una marca",
    SELECTED_CAMPAIGN: "Campaña seleccionada",
    ACTIVE_CAMPAIGN: "Campaña activa",
    SELECTED_CAMPAIGN_DESCRIPTION:
      "Estás viendo los datos de la campaña “{{campaignName}}”",
    SELECT_SPECIFIC_CAMPAIGN:
      "Selecciona una campaña concreta para ver solo datos sobre ella.",
    SEARCH_CAMPAIGN: "Buscar una campaña",
    GENERAL_SALES_INFO:
      "Este es el importe en dólares de las ventas que has generado a partir de tus referencias.",
    KWIKCASH_INFO: "Este es el importe que has ganado de tus referencias.",
    TOTAL_REFERRALS: "Total de referencias",
    SALES_GENERATED: "Ventas generadas",
    WAVE_NUMBER: "Onda{{number}}",
    MEMBERS: "Miembros",
    MEMBERS_NUMBER: "Miembros ({{number}})",
    SEARCH_MEMBER: "Buscar miembro",
    RECENT_REFERRALS: "Referencias recientes",
    ALL_REFERRALS: "Todas las referencias",
    SHOPPING_PV: "PV",
    POLICY_POLICIES: "Políticas",
    POLICY_VTPTTBHUTK: "Ver las políticas que la marca ha subido a Kwik",
    POLICY_SHIPPING_POLICY: "Política de envío",
    POLICY_TAC: "Términos y condiciones",
    POLICY_RP: "Política de devoluciones",
    POLICY_PP: "Política de privacidad",
    POLICY_NOT_SEEING:
      "¿No ves lo que quieres?  Ponte en contacto con la marca directamente",
    DASHBOARD_PROFILE_STATUS: "Primeros pasos",
    DASHBOARD_GET_5_CASHBACK:
      "¡Completa los 5 pasos para obtener un cashback de 5 €!",
    DASHBOARD_COMPLETE_STEPS_EXPERT:
      "¡Completa estos pasos para convertirte en experto!",
    DASHBOARD_CREATE_ACCOUNT: "Crea una cuenta",
    DASHBOARD_ALREADY_CREATED: "Ya creada",
    DASHBOARD_DONE: "¡Hecho!",
    DASHBOARD_FAPOCWAB: "Encuentra un producto o conecta con una marca",
    DASHBOARD_MAKE_A_REFER: "Hacer una referencia",
    DASHBOARD_SEE_ROLLIN: "¡Genial! Ver el dinero rodando",
    DASHBOARD_SRAPTAF: "Referenciar un producto a un amigo con éxito",
    DASHBOARD_SHOW_ME_MONEY: "Enséñame el dinero",
    DASHBOARD_SEE_YOUR_IMPACT: "Ver tu impacto",
    DASHBOARD_CLAIM_REWARD: "Reclamar recompensa",
    DASHBOARD_UPLOAD_IMAGE: "Subir imagen",
    DASHBOARD_HEY: "Hola",
    DASHBOARD_WELCOME_TO_KWIK:
      "¡Bienvenido a WeR1! Este es el panel de control. Aquí aprenderás todo lo que necesitas saber sobre WeR1 y cómo empezar a compartir y ganar. Además, ¡hay dinero gratis en la sección «Primeros pasos» a la derecha!",
    DASHBOARD_WELCOME_TO_KWIK_MOBILE:
      "¡Bienvenido a WeR1! Este es el panel de control. Aquí aprenderás todo lo que necesitas saber sobre WeR1 y cómo empezar a compartir y ganar. Además, ¡hay dinero gratis en la sección «Primeros pasos» de abajo!",
    DASHBOARD_WELCOME_TO_KWIK2:
      "¡Bienvenido a WeR1! ¡Estamos\\ entusiasmados con tu reciente compra! Queremos ayudarte a compartirla con tus conocidos de forma provechosa.",
    DASHBOARD_WELCOME_TO_KWIK3:
      "Es posible que las cosas se vean un poco diferentes por aquí. Si te perdiste la última actualización, ¡haz clic aquí para ver todas las nuevas funciones añadidas a WeR1!",
    DASHBOARD_WELCOME_TO_KWIK4:
      "Bienvenido a WeR1. Es la forma más fácil y gratificante de recomendar tus productos a amigos y seguidores.",
    DASBOARD_LOOK_TO_THE_RIGHT: "Mira a la derecha",
    DASBOARD_LOOK_TO_BELOW: "Mira abajo",
    DASHBOARD_SALES_GENERATED: "Ventas generadas",
    DASHBOARD_VIEW_ANALYTICS: "Ver Analytics",
    DASHBOARD_NOTIFICATION: "Notificaciones",
    DASHBOARD_PURCHASED_FORM_YOUR_LINK: "Comprado desde tu enlace",
    MOST_RECENT: "Más reciente",
    KWIK: "Kwik",
    KB_VERSION: "KB",
    KB_THANKYOU: "Gracias!",
    KB_TITLE_01: "Nuevos correos electrónicos",
    KB_TITLE_02: "Aumento de nivel de KwikCash",
    KB_TITLE_03: "Cambios en la página Compartir",
    KB_TITLE_04: "Pequeñas mejoras",
    KB_TITLE_05: "Eso es todo amigos",
    KB_TITLE_06: "Corrección de errores",
    WELCOME_KWIK:
      "¡Bienvenido a la 1.3.7! Esto es importante, ya que la app acaba de estrenar otra pantalla totalmente rediseñada. Échale un vistazo y entérate de otros cambios.",
    THANKYOU_KWIK:
      "Estamos\\ muy contentos con esta versión y más emocionados por la próxima. Déjanos tu opinión en <span>hello@wer1.com</span>, ¡leemos todos los comentarios y los tenemos en cuenta!",
    WELCOME_KWIK_01: "¡Comprueba qué hay de nuevo!",
    VERSION_DESC_01:
      "¡Hay todos los nuevos correos electrónicos en Kwik! Se ajusta a nuestro estilo único y es mucho más eficaz que los correos electrónicos anteriores.",
    VERSION_DESC_02:
      "¡El dinero ganado en Kwik es esencial! El diseño ahora refleja eso.",
    VERSION_DESC_03:
      "Hacer que compartir sea más accesible y divertido es nuestro objetivo con cada versión. Así que echa un vistazo al nuevo diseño.",
    VERSION_DESC_04:
      "Hay muchos cambios pequeños en esta versión, aquí tienes algunos.",
    VERSION_DESC_05:
      "Muchas gracias por participar en la versión beta de Kwik. Envía tu feedback a<span>hello@wer1.com</span>. Queremos escuchar tus sugerencias. Disfruta la 1.3.7.",
    VERSION_DESC_06:
      "Hay un montón de nuevas correcciones de errores en la versión 1.3.6, consulta las notas de la versión para ver más, o simplemente echa un vistazo en Kwik. ¡Todos los detalles están mejorando!",
    BASEHEADER_LINK_DASHBOARD: "Panel de control",
    NEW_SHARE_LINK_SAVE_FOR_LATER: "Guardar para más tarde",
    NEW_SHARE_LINK_CART_TEXT_WHAT_WANT_SAVED:
      "¿Quieres ver lo que has guardado? ",
    NEW_SHARE_LINK_CART_TEXT_OR: " o ",
    NEW_SHARE_LINK_CART_TEXT_CREATE_ACCOUNT: "Crea una cuenta",
    NEW_SHARE_LINK_CART_TEXT_SIGN_IN: "Iniciar sesión",
    NEW_CHECKOUT_SELECT_SHIPPING_RATE:
      "Seleccionar un método de envío por marca",
    NEW_CHECKOUT_TITLE_CART: "Carrito:",
    DASHBOARD_WELCOME_BACK: "Bienvenido de nuevo",
    DASHBOARD_MY_ORDERS: "Mis pedidos",
    DASHBOARD_NO_ORDERS: "No hay pedidos",
    DASHBOARD_MADE_ORDER_TIPS:
      "¡Parece que no has realizado ningún pedido de una marca a través de Kwik!",
    DASHBOARD_RECENT_SHARE: "Compartido recientemente",
    DASHBOARD_SHARE_OTHER_PRODUCTS: "Compartir otros productos",
    DASHBOARD_SEE_MORE: "Ver más",
    DASHBOARD_SHOW_LESS: "Mostrar menos",
    DASHBOARD_WELCOME: "Bienvenido",
    ALREADY_SHARED_FAVOURITE:
      "Ya compartes tus productos favoritos. Te lo ponemos fácil para que ganes las comisiones que te mereces.",
    SHOW_ME_HOW: "Muéstrame cómo",
    ALREADY_BRAND_AMBASSADOR: "— Ya eres embajador oficial de la marca",
    WHY_MAKE_AMBASSADOR:
      "¿Por qué no hacerlo oficial? Kwik te ofrece las herramientas que necesitas para compartir y ganar dinero de forma sencilla y divertida",
    MEET_SHARE_PAGE: "— Conoce la página Compartir",
    MEET_SHARE_PAGE_DESC:
      "Este es tu nuevo mejor amigo. Es donde encontrarás todos tus enlaces de referencias y campañas de productos.",
    SHARE_PAGE_FEATURE: "— Funciones de la página Compartir",
    SHEARCH_FAVOURITE_PRODUCT:
      "<ul><li>Busca tus productos y marcas favoritas que puedas compartir.</li><li>Comparte productos individuales o el catálogo completo de la marca.</li></ul>",
    CUSTOM_LINKS_COLLECTION: "— Enlaces y colecciones personalizados",
    PERSONAL_SHARE_LINK:
      "<ul><li>Personaliza tu enlace para compartir con mensajes, imágenes, vídeos y reseñas personalizados. </li><li>Crea una colección de múltiples productos basados en intereses y actividades compartidas.</li></ul>",
    GOT_IT: "Entendido",
    MEET_KWIK_CASH: "— ¡Conoce KwikCash!",
    BEST_PART_USING_KWIK:
      "La mejor parte de usar Kwik: ¡el dinero! \n KwikCash se muestra de dos formas: disponible y pendiente. Las ganancias estarán disponibles cuando finalice el periodo de devolución.",
    MONEY_MOVES: "— Movimientos de dinero",
    MONEY_MOVE_DESC:
      "<ul><li>Cobrar a través de ACH o PayPal</li><li>Consulta tu KwikCash, comprueba dónde lo has ganado, cómo lo has gastado y cuándo estarán disponibles tus últimas ganancias.</li><li>Más información sobre KwikCash aquí.</li></ul>",
    MEET_CAMPAIGNS: "— Conocer las campañas",
    MEET_CAMPAIGNS_DESC:
      "Aquí es donde ponemos a trabajar nuestra tecnología blockchain. \n Realizamos un seguimiento de cada enlace para que puedas ver el verdadero impacto de tus recomendaciones de productos",
    KEY_FEATURES: "— Funciones principales",
    KEY_FEATURE_DESC:
      "<ul><li>Los datos se desglosan en tres niveles: todas las campañas, campañas sueltas y productos individuales.</li><li>¡Utiliza las ondas para ver cómo una referencia puede convertirse en muchas!</li></ul>",
    ADDITIONAL_FEATURES: "— Funciones adicionales",
    ADDITIONAL_FEATURES_DESC:
      "<ul><li>Perdido? Haz clic en el icono 'I' para obtener más información.</li><li>Para obtener más información sobre cómo funcionan las ondas de ganancias o cómo funcionan las campañas, <a href='https://kwik.com/work' target='_blank'>haz clic aquí</a>.</li></ul>",
    KWIK_TEAM: "— Equipo Kwik",
    KWIK_TEAM_QUESTION:
      "<p>¿Tienes preguntas o feedback? ¡Queremos saber tu opinión! Envíanos un correo electrónico a <a href='mailto:hello@wer1.com'>hello@wer1.com</a></p><p>PD: Leemos todos los mensajes :) ¡Gracias por ayudarnos a hacer Kwik aún mejor!</p>",
    IAMREADY: "Estoy preparado",
    DASHBOARD_PAGE: "— Página Panel de control",
    DASHBOARD_DESCRIPTION:
      "<p>Tu panel de datos muestra los pedidos pasados, Aviso, las campañas y los consejos para provocar ondas con las referencias de productos.</p><p>Encontrarás algunos datos básicos, ¡y te ayudará a empezar!</p>",
    I_GOT_IT: "Entendido",
    DASHBOARD_CHECK_YOUR_EARINGS: "Verifique sus ganancias",
    DASHBOARD_BLOG_ARTICLES: "Blog / Artículos",
    SETTINGS_GENERAL_CONTACT_REFERRER_FIRST_NAME:
      "Nombre de pila del referenciador",
    SETTINGS_GENERAL_CONTACT_REFERRER_LAST_NAME: "Apellido del referenciador",
    SETTINGS_GENERAL_CONTACT_REFERRER_NAME: "Nombre del referenciador",
    SETTINGS_GENERAL_CONTACT_REFERRER_EMAIL:
      "Correo electrónico del referenciador",
    VENDOR_FINANCE_TABLE_HD_DATE: "Fecha",
    VENDOR_FINANCE_TABLE_HD_TRANSACTION_STATUS: "Estado de la transacción",
    VENDOR_FINANCE_TABLE_HD_TRANSACTION_METHOD: "Método de transacción",
    VENDOR_FINANCE_TABLE_HD_NET_PAYMENT: "Pago neto",
    VENDOR_FINANCE_TABLE_HD_TYPE: "Tipo",
    VENDOR_FINANCE_TABLE_HD_KWIKCASH_TYPE: "Tipo de KwikCash",
    VENDOR_FINANCE_TABLE_HD_AMOUNT: "Importe",
    VENDOR_FINANCE_TABLE_HD_BALANCE: "Saldo",
    CAMPAIGNS_SELECTED_KWIKCASH: "1Cash",
    CAMPAIGNS_MY_CAMPAIGNS_THESE_ARE_THE_MESSAGE:
      "Estas son las campañas en las que estás participando. Para ganar más campañas, compra un producto de esa marca o solicita directamente a la marca ser embajador.",
    CAMPAIGNS_IMPACTFULRECOMMEND_THIS_WILL_SHOW_MESSAGE:
      "Esto te indicará a quién has referenciado que te ha generado más ingresos.",
    DASHBOARD_SEE_LESS: "Ver menos",
    SHARELIINK_REGISTER_PASSWORD_PLACEHOLDER: "Contraseña de +8 caracteres",
    JOIN_CAMPAIGN_INFO:
      "Para formar parte de una campaña, debes tener experiencia con el producto. Compra el producto que quieres promocionar o ponte en contacto con el servicio de atención al cliente en relación con las compras anteriores realizadas antes de unirte a Kwik. Pronto habrá más formas de unirse a una campaña.",
    MAKE_REFERRAL_INFO:
      "Comparte un enlace a cualquier producto con cualquier persona. Si hacen una compra, ¡has hecho una referencia con éxito y puedes marcarla en tu lista!",
    CHECK_EARNINGS_INFO:
      "Fácil, solo tienes que ir a la página de KwikCash a través de la navegación.",
    CHECK_WAVES_INFO:
      "Ir a la página de campañas a través del menú de navegación.",
    CAMPAIGNS_ALL_CAMPAIGNS: "Todas las campañas",
    CAMPAIGNS_WAVE_INSTANT_CASH_BACK: "Cashback instantáneo",
    CAMPAIGNS_WAVE_RECENT_CASH_BACK_ORDERS: "Órdenes recientes de cashback",
    CAMPAIGNS_WAVE_ALL_CASH_BACK_ORDERS: "Todas las órdenes de cashback",
    CAMPAIGNS_WAVE_CASHBACK_EARNED: "Cashback ganado",
    ALL_TIME2: "Todo el tiempo",
    DASHBOARD_THIS_MONTH_ITEM2: "Este mes",
    LAST_DAY2: "Últimos {{day}} días",
    CAMPAIGNS_NO_SHARED_PRODUCTS: "No hay productos compartidos",
    CAMPAIGNS_NO_MADE_REFERRALS:
      "Parece que aún no has hecho ninguna referencia o recomendación.",
    CAMPAIGNS_SHARE_SOMETHING: "Compartir algo",
    CAMPAIGNS_NO_WAVES: "Sin ondas",
    CAMPAIGNS_ONLY_WORKS:
      "¡Las ondas solo funcionan cuando compartes con tus amigos!",
    CAMPAIGNS_WAVE_TEXT_REFERRALS: "Referencias",
    YOUR_ACCOUNT_ALMOST_CREATED: "¡Tu cuenta está casi creada!",
    ORDER_DETAIL_REVIEW_CONTENT_MESSAGE: "¡Por favor, deja tu reseña!",
    NEW_CHECKOUT_DELIVERY_INFORMATION: "Información de entrega",
    NEW_CHECKOUT_EDIT: "Editar",
    NEW_CHECKOUT_SHIPPING_METHOD: "Método de envío",
    NEW_CHECKOUT_PAYMENT_METHOD: "Método de pago",
    ENTER_LOGIN_EMAIL_NEW:
      "¡Introduce tu correo electrónico y nosotros haremos el resto!",
    KWIKCASH_BALANCE_TITLE_AVAILABLE: "Saldo disponible",
    KWIKCASH_BALANCE_TITLE_PENDING: "Pendiente",
    KWIKCASH_BALANCE_SEARCH_TRANSACTION_ID: "Buscar transacciones / ID",
    KWIKCASH_BALANCE_VIEW_TRANSACTIONS: "Ver transacciones",
    KWIKCASH_ALL_TIME: "Todo el tiempo",
    KWIKCASH_THIS_MONTH: "Este mes",
    KWIKCASH_LAST_7_DAYS_1: "Últimos ",
    KWIKCASH_LAST_7_DAYS_2: "7 días",
    KWIKCASH_TEXT_TRANSACTIONS: "Transacciones",
    KWIKCASH_TEXT_JOINED_WAVES: "Ondas unidas",
    KWIKCASH_TEXT_Earnings: "Ganancias",
    KWIKCASH_CASH_OUT_TITLE: "Métodos de cobro",
    KWIKCASH_BTN_CASH_OUT: "Cobrar",
    KWIKCASH_ADD_PAYMENT_BTN_NEXT_STEP: "Siguiente paso",
    KWIKCASH_ADD_PAYMENT_BTN_BACK: "Atrás",
    KWIKCASH_ADD_PAYMENT_SELECT_TYPE_TITLE: "Seleccionar tipo",
    KWIKCASH_ADD_PAYMENT_SELECT_TYPE_MSG:
      "Selecciona el tipo de cuenta que quieres añadir.",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_TITLE: "Añadir banco",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_1:
      "Introduce los datos que aparecen a continuación para ",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_2: "Añadir cuenta bancaria",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_3:
      "Esta información se guardará de forma segura según los ",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_4: "Términos de servicio y ",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_5: "la Política de privacidad",
    KWIKCASH_ADD_PAYMENT_ADD_PAYPAL_MSG_1:
      "Introduce los datos que aparecen a continuación para ",
    KWIKCASH_ADD_PAYMENT_ADD_PAYPAL_MSG_2: "Añadir una cuenta de PayPal",
    KWIKCASH_CASH_OUT_TRANSFER_AMOUNT: "Importe de la transferencia",
    KWIKCASH_CASH_OUT_MSG1:
      "*Puedes transferir el importe fácilmente a cualquiera de las cuentas vinculadas",
    KWIKCASH_CASH_OUT_METHOD: "Métodos de cobro",
    KWIKCASH_CASH_OUT_MSG21: "Empieza añadiendo tu primer ",
    KWIKCASH_CASH_OUT_MSG22: "método de",
    KWIKCASH_CASH_OUT_MSG23: " cobro",
    KWIKCASH_CASH_OUT_ADD: "Añadir método",
    KWIKCASH_CASH_OUT_LEARN_MORE: "Más información",
    KWIKCASH_TRANSACTION_STATUS_TIPS_DELIVERED: "¡Deberías tener tu dinero!",
    KWIKCASH_TRANSACTION_STATUS_TIPS_INPROCESS:
      "El cobro está en proceso de llegar a tu cuenta",
    KWIKCASH_TRANSACTION_STATUS_TIPS_CANCELED: "Este cobro ha sido cancelado",
    KWIKCASH_TRANSACTION_STATUS_TIPS_ONHOLD:
      "Nuestro equipo está revisando el cobro. El equipo de Kwik revisará cualquier cobro de más de 500 €. Debería tardar menos de 24 horas.",
    KWIKCASH_TRANSACTION_CASH_OUT: "Transacciones de cobro",
    KWIKCASH_TRANSACTION_EXPORT: "Exportar",
    KWIKCASH_TRANSACTION_TABLE_HEADER_TYPE: "Tipo",
    KWIKCASH_TRANSACTION_TABLE_HEADER_DATE: "Fecha",
    KWIKCASH_TRANSACTION_TABLE_HEADER_TRANSACTION_ID: "ID de transacción",
    KWIKCASH_TRANSACTION_TABLE_HEADER_AMOUNT: "Importe",
    KWIKCASH_TRANSACTION_TABLE_HEADER_STATUS: "Estado",
    KWIKCASH_TRANSACTION_TABLE_HEADER_TRANSACTION_TYPE: "Tipo de transacción",
    KWIKCASH_TRANSACTION_TABLE_HEADER_BALANCE: "Saldo",
    KWIKCASH_TRANSACTION_TABLE_HEADER_WAVE: "Onda",
    KWIKCASH_TRANSACTION_TABLE_HEADER_INFLUENCER: "Influencer",
    KWIKCASH_TRANSACTION_TABLE_HEADER_AVAILABLE_DATE: "Fecha disponible",
    KWIKCASH_TRANSACTION_NO_DATA_TITLE: "No hay transacciones para mostrar",
    KWIKCASH_TRANSACTION_NO_DATA_DESCRIPTION1:
      "Comienza a compartir tus productos con amigos para ",
    KWIKCASH_TRANSACTION_NO_DATA_DESCRIPTION2: "Ganar 1Cash",
    KWIKCASH_TRANSACTION_NO_DATA_DESCRIPTION3:
      " Luego cobra tus ganancias y aparecerán aquí :)",
    KWIKCASH_TRANSACTION_NO_DATA_BTN_START_SHARING: "Empieza a compartir",
    KWIKCASH_TRANSACTION_DETAIL_BACK: "Atrás",
    KWIKCASH_TRANSACTION_DETAIL_TRANSACTIONS: "Transacciones",
    KWIKCASH_TRANSACTION_DETAIL_NO_DATA: "No hay transacciones para mostrar",
    KWIKCASH_TRANSACTION_DETAIL_DESCRIPTION1:
      "Comienza a compartir tus productos con amigos para ",
    KWIKCASH_TRANSACTION_DETAIL_DESCRIPTION2: "Ganar KwikCash",
    KWIKCASH_TRANSACTION_DETAIL_DESCRIPTION3:
      " Luego cobra tus ganancias y aparecerán aquí :)",
    KWIKCASH_VERIFY_NUMBER_TEXT_1: "Antes de continuar con 1Cash, verifica tu",
    KWIKCASH_VERIFY_NUMBER_TEXT_2: " Correo electrónico",
    KWIKCASH_VERIFY_NUMBER_BTN: "Verificar ahora",
    KWIKCASH_CASH_OUT_TIPS_SELECT_CARD: "¡Selecciona una tarjeta bancaria!",
    KWIKCASH_CASH_OUT_MINIMUM_AMOUNTS:
      "¡Los importes mínimos deben ser{{currency}}{{amount}}!",
    KWIKCASH_CASH_OUT_TIPS_AMOUNT_INVALID:
      "No puedes realizar un cobro superior a tu saldo disponible",
    KWIKCASH_CASH_OUT_TIPS_SENT_SUCCESS: "Código enviado con éxito",
    KWIKCASH_CASH_OUT_MODAL_TITLE: "Cobrar",
    KWIKCASH_CASH_OUT_TIPS_MSG1: "Introduce tu ",
    KWIKCASH_CASH_OUT_TIPS_MSG2: "código de 4 dígitos",
    KWIKCASH_CASH_OUT_TIPS_MSG3: "para cobrar",
    KWIKCASH_CASH_OUT_TITLE_VERIFY: "Verificar para cobrar",
    KWIKCASH_CASH_OUT_TIPS_SENT_TO1: "El código se envía a ",
    KWIKCASH_CASH_OUT_TIPS_DONT_RECEIVE: "¿No hasrecibido un código? ",
    KWIKCASH_CASH_OUT_LINK_REQUEST_AGAIN: "Solicitar de nuevo",
    KWIKCASH_CASH_OUT_CONTENT_MSG1: "Selecciona tu ",
    KWIKCASH_CASH_OUT_CONTENT_MSG2: "Método de cobro",
    KWIKCASH_CASH_OUT_CONTENT_MSG3:
      ", luego introduce el importe y ¡pulsa transferir!",
    KWIKCASH_CASH_OUT_AVAILABLE_BALANCE: "Saldo disponible",
    KWIKCASH_CASH_OUT_SELECT_METHOD: "Selecciona un método de pago",
    KWIKCASH_CASH_OUT_TO_CITY_BANK: "A City Bank",
    KWIKCASH_CASH_OUT_TITLE_SUCCESS: "¡Transferencia realizada con éxito!",
    KWIKCASH_CASH_OUT_SUCCESS_MSG1:
      "Tu pago se ha transferido correctamente, tardará ",
    KWIKCASH_CASH_OUT_SUCCESS_MSG2: "9-10 días laborables",
    KWIKCASH_CASH_OUT_SUCCESS_MSG3: " en procesarse",
    KWIKCASH_VERIFY_ENTER_EMAIL:
      "Introduce una dirección de correo electrónico válida",
    KWIKCASH_VERIFY_ENTER_4_CODE: "Introduce el código de 4 dígitos",
    KWIKCASH_VERIFY_EMAIL: "Verificar correo electrónico",
    KWIKCASH_VERIFY_TIPS_1:
      "Te enviaremos un código a tu correo electrónico para verificar que es tuyo",
    KWIKCASH_VERIFY_TIPS_ENTER_EMAIL: "Introduce tu correo electrónico",
    KWIKCASH_VERIFY_MAKE_SURE_EMAIL:
      "Asegúrate de que has introducido el correo electrónico correcto.",
    KWIKCASH_VERIFY_CODE_SENT_TO: "El código ha sido enviado a ",
    KWIKCASH_VERIFY_ENTER_EMAIL_CHECK:
      "El correo electrónico debe ser el correo electrónico de inicio de sesión",
    KWIKCASH_ADD_DIFFERENT_NUM: "Los dos números de cuenta son diferentes",
    KWIKCASH_ADD_SELECT_PAYMENT: "Selecciona un tipo de pago",
    KWIKCASH_ADD_ACCOUNT_ADDED: "Cuenta bancaria añadida",
    KWIKCASH_ADD_ADDED_TIPS_1:
      "¡Parece que tienes todo listo para ponerte en marcha! Tu cuenta bancaria aparecerá ahora como una opción para cobrar. Disfruta de tu dinero :)",
    KWIKCASH_ADD_ADDED_PAYPAL: "Cuenta PayPal añadida",
    KWIKCASH_ADD_ADDED_TIPS_PAYPAL_1:
      "¡Parece que tienes todo listo para ponerte en marcha! Tu cuenta de Paypal aparecerá ahora como una opción para cobrar. Disfruta de tu dinero :)",
    KWIKCASH_ADD_VERIFY_TIPS_1: "Introduce tu ",
    KWIKCASH_ADD_VERIFY_TIPS_2: "código de 4 dígitos",
    KWIKCASH_ADD_VERIFY_TIPS_3: " a ",
    KWIKCASH_ADD_VERIFY_TIPS_ADD_PAYPAL: "Añadir PayPal",
    KWIKCASH_ADD_VERIFY_TIPS_ADD_BANK: "Añadir banco",
    KWIKCASH_EDIT_BANK_ACCOUNT: "Editar cuenta bancaria",
    KWIKCASH_EDIT_VERIFY_REALLY_YOU: "Verificar que realmente eres tú",
    KWIKCASH_EDIT_PAYPAL_ACCOUNT: "Editar cuenta PayPal",
    KWIKCASH_EDIT_PAYPAL_MSG_1:
      "Esta información se guardará de forma segura según los",
    KWIKCASH_EDIT_PAYPAL_MSG_2: "Términos de servicio y ",
    KWIKCASH_EDIT_PAYPAL_MSG_3: "la Política de privacidad",
    KWIKCASH_EDIT_PAYPAL_VERIFY_MSG_1:
      "Verifica que eres tú a continuación para ",
    KWIKCASH_EDIT_PAYPAL_VERIFY_MSG_2: "Editar una cuenta PayPal",
    KWIKCASH_EDIT_BANK_VERIFY_MSG_2: "Editar una cuenta bancaria",
    KWIKCASH_TIPS_SELECT_COUNTRY: "¡Selecciona el país!",
    KWIKCASH_TIPS_SELECT_CURRENCY: "Selecciona una moneda",
    KWIKCASH_MANAGE_CASH_OUT_METHOD: "Gestiona tus métodos de cobro",
    KWIKCASH_CASH_OUT_METHOD2: "Métodos de cobro",
    KWIKCASH_ITS_EASY: "¡Es superfácil!",
    KWIKCASH_MANAGE_BTN_ADD: "Añadir +",
    KWIKCASH_MANAGE_BTN_EDIT: "Editar",
    KWIKCASH_MANAGE_BTN_CANCEL: "Cancelar",
    KWIKCASH_MANAGE_TIPS_SELECT_METHOD:
      "Selecciona un método de cobro para editar",
    KWIKCASH_MANAGE_REMOVE_PAYPAL: "Eliminar PayPal",
    KWIKCASH_MANAGE_REMOVE_CARD: "Eliminar Cuenta",
    KWIKCASH_MANAGE_TO_REMOVE_PAYPAL: " para eliminar tu PayPal",
    KWIKCASH_MANAGE_TO_REMOVE_CARD: " para eliminar tu cuenta",
    KWIKCASH_MANAGE_VERIFY_REMOVE: "Verificar para eliminar ",
    KWIKCASH_MANAGE_VERIFY_TO: "Verificar para ",
    KWIKCASH_MANAGE_WORD_PAYPAL: "PayPal",
    KWIKCASH_MANAGE_WORD_CARD: "Cuenta",
    KWIKCASH_MANAGE_WORD_BANK: "Banco",
    KWIKCASH_MANAGE_ACCOUNT_REMOVED: " Cuenta eliminada",
    KWIKCASH_MANAGE_REMOVE_TIPS_1:
      "Una vez que elimines una tarjeta, se borrará de Kwik",
    KWIKCASH_MANAGE_BANK_ACCOUNT_UPDATED: "Cuenta bancaria actualizada",
    KWIKCASH_MANAGE_PAYPAL_ACCOUNT_UPDATED: "Cuenta PayPal actualizada",
    KWIKCASH_MANAGE_BTN_ADD_ACCOUNT: "Verificar y añadir cuenta",
    KWIKCASH_BTN_CONFIRM_NUMBER: "Confirmar número",
    KWIKCASH_BTN_CONFIRM_EMAIL: "Confirmar correo electrónico",
    VENDOR_SETTINGS_UP: "Usuarios y permisos",
    VENDOR_SETTINGS_MWUCSODIYS:
      "Gestiona lo que los usuarios pueden ver o hacer en tu tienda.",
    VENDOR_SETTINGS_BRAND_OWER: "Propietario de la marca",
    VENDOR_SETTINGS_ADDS_MEMBERS_TIPS: "Miembros añadidos (hasta 15)",
    VENDOR_SETTINGS_NO_DATA_TIPS:
      "No has añadido ningún usuario. Añade usuarios para ver los detalles",
    VENDOR_SETTINGS_LAST_LOGIN: "El último inicio de sesión fue",
    VENDOR_SETTINGS_ADD_USERS: "Añadir usuario",
    VENDOR_SETTINGS_EDIT_USERS: "Editar usuario",
    VENDOR_SETTINGS_ETU_GOVERNMENTID:
      "Introduce el nombre y los apellidos del usuario tal y como aparecen en el DNI.",
    VENDOR_SETTINGS_SELECT_PERMISSIONS: "Seleccionar permisos",
    VENDOR_SETTINGS_SELECT_ALL: "Seleccionar todo",
    VERSION_DETAIL_01: "Biografía del vendedor",
    VERSION_DETAIL_02: "Eliminación de descripciones cortas",
    VERSION_DETAIL_03: "Información de referencia del vendedor",
    VERSION_DETAIL_04: "No hay nombres en las reseñas",
    VERSION_DETAIL_05: "Editar carrito de la compra",
    VERSION_DETAIL_06:
      "Mostrar logotipo del vendedor en la pantalla de compra posterior",
    VERSION_DETAIL_07: "Correcciones gramaticales",
    VERSION_DETAIL_08: "Mostrando datos incorrectos",
    VERSION_DETAIL_09: "Mostrar datos específicos del producto",
    INVALID_LINK: "Enlace no válido",
    ORDER_LIST_ORDER_DATE: "Fecha del pedido",
    VENDOR_ACCEPTING_ORDERS_STEP_1: "PASO 1",
    VENDOR_ACCEPTING_ORDERS_STEP_2: "PASO 2",
    VENDOR_ACCEPTING_ORDERS_STEP_3: "PASO 3",
    VENDOR_ACCEPTING_ORDERS_STEP_4: "PASO 4",
    VENDOR_ACCEPTING_ORDERS_STEP_5: "PASO 5",
    VENDOR_ACCEPTING_ORDERS_STEP_6: "PASO 6",
    VENDOR_ACCEPTING_ORDERS_TITLE_1:
      "Configura desde dónde se envían tus productos",
    VENDOR_ACCEPTING_ORDERS_TITLE_2: "Añadir productos",
    VENDOR_ACCEPTING_ORDERS_TITLE_3: "Personaliza tus campañas",
    VENDOR_ACCEPTING_ORDERS_TITLE_4: "Fija tus tarifas de envío",
    VENDOR_ACCEPTING_ORDERS_TITLE_5: "Personaliza tu marca",
    VENDOR_ACCEPTING_ORDERS_TITLE_6: "Personaliza tu marca",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_1:
      "Esto asegurará que la cantidad se rastree adecuadamente y ayudará con la coordinación del envío. Ya hemos establecido una dirección como dirección de tu empresa. Actualízala si es incorrecta o tienes más de una localización.",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_2:
      "Dinos cuáles de tus productos quieres Kwikificar y nos encargaremos de ello. Sólo necesitamos información sobre cada producto que quieras. Añade esa información con nuestro plugin Shopify, CVS Import, o manualmente.",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_3:
      "Es más fácil tener una campaña, por lo que ya la configuramos de esa manera por defecto. Esto significa que cuando alguien se une a tu campaña, tiene acceso para compartir todos tus productos. Si quieres separarlos en diferentes campañas, ¡no dudes en hacerlo!",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_4:
      "Este paso solo es necesario si quieres participar en el Marketplace de Kwik, si estás interesado en eso, solo tienes que hacer clic aquí y te enseñaremos algunas ventajas :) Si no es así, sigue los clics y verás que todo va bien. ",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_5:
      "Necesitamos algunos de tus geniales diseños de marca para que la experiencia de tus clientes en Kwik sea aún mejor. Danos algunos colores, imágenes, biografía, etc.",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_6:
      "Necesitamos algunos de tus geniales diseños de marca para que la experiencia de tus clientes en Kwik sea aún mejor. Danos algunos colores, imágenes, biografía, etc.",
    VENDOR_ACCEPTING_ORDERS_BTN_11_NAME: "Editar almacén",
    VENDOR_ACCEPTING_ORDERS_BTN_21_NAME: "Añadir productos",
    VENDOR_ACCEPTING_ORDERS_BTN_31_NAME: "Personalizar campañas",
    VENDOR_ACCEPTING_ORDERS_BTN_41_NAME: "Fijar tarifas de envío",
    VENDOR_ACCEPTING_ORDERS_BTN_42_NAME: "No me interesa",
    VENDOR_ACCEPTING_ORDERS_BTN_51_NAME: "Personalizar mi marca",
    VENDOR_ACCEPTING_ORDERS_BTN_61_NAME: "Personalizar mi cuenta bancaria",
    VENDOR_ACCEPTING_ORDERS_MENU_1: "Personaliza tus almacenes",
    VENDOR_ACCEPTING_ORDERS_MENU_2: "Añadir productos",
    VENDOR_ACCEPTING_ORDERS_MENU_3: "Personaliza tus campañas",
    VENDOR_ACCEPTING_ORDERS_MENU_4: "Configura tus campañas",
    VENDOR_ACCEPTING_ORDERS_MENU_5: "Personaliza tu marca",
    VENDOR_ACCEPTING_ORDERS_MENU_6: "Conecta tu cuenta bancaria",
    VENDOR_ACCEPTING_ORDERS_TEXT_OF_6: " de 6",
    VENDOR_ACCEPTING_ORDERS_TEXT_COMPLETED: " Completado",
    VENDOR_ANALYTIC_REPORT_TITLE: "Informe analítico",
    VENDOR_ANALYTIC_REPORT_TITLE_1: "Total de ventas",
    VENDOR_ANALYTIC_REPORT_TITLE_2: "Total de pedidos",
    VENDOR_ANALYTIC_REPORT_TITLE_3: "Nuevos clientes",
    VENDOR_ANALYTIC_REPORT_TITLE_4: "Compartir clientes",
    VENDOR_ANALYTIC_REPORT_TIPS_1: "-----",
    VENDOR_OVERVIEW_COMPLETE_STEP_TITLE: "Completar la configuración",
    VENDOR_OVERVIEW_COMPLETE_STEP_TAX_RATES_TITLE:
      "Configura tus tasas de impuestos",
    VENDOR_OVERVIEW_COMPLETE_STEP_TAX_RATES_MESSAGE:
      "Tenemos que asegurarnos de que eres legal y estás en disposición de pagar impuestos",
    VENDOR_OVERVIEW_COMPLETE_STEP_TAX_RATES_BTN_NAME: "Fijar tasa de impuestos",
    VENDOR_OVERVIEW_COMPLETE_STEP_ADD_TITLE: "Añadir embajadores",
    VENDOR_OVERVIEW_COMPLETE_STEP_ADD_MESSAGE:
      "No tienes compartidores añadidos, dale un enlace a algunos de tus clientes fieles",
    VENDOR_OVERVIEW_COMPLETE_STEP_ADD_BTN_NAME: "Añadir usuarios",
    VENDOR_OVERVIEW_CUSTOMIZATION_TITLE: "Personalización",
    VENDOR_OVERVIEW_CUSTOMIZATION_BRAND_TITLE: "Personaliza tu marca",
    VENDOR_OVERVIEW_CUSTOMIZATION_BRAND_MESSAGE:
      "Actualiza los colores y logotipos que quieres que vean los usuarios. Haz que tu marca sea tuya.",
    VENDOR_OVERVIEW_CUSTOMIZATION_BRAND_BTN_NAME: "Vamos a personalizar",
    VENDOR_OVERVIEW_CUSTOMIZATION_FINANCES_TITLE: "Añade tus finanzas",
    VENDOR_OVERVIEW_CUSTOMIZATION_FINANCES_MESSAGE:
      "Asegúrate de que puedes obtener tu dinero por las ventas y de que tienes un método para pagar a los que venden tus productos",
    VENDOR_OVERVIEW_CUSTOMIZATION_FINANCES_BTN_NAME: "Actualizar ahora",
    VENDOR_OVERVIEW_EARNERS_TITLE: "Los que más ganan",
    VENDOR_OVERVIEW_TABLE_TITLE: "Productos más vendidos",
    VENDOR_OVERVIEW_TABLE_HEADER_1: "Imagen",
    VENDOR_OVERVIEW_TABLE_HEADER_2: "Nombre del producto",
    VENDOR_OVERVIEW_TABLE_HEADER_3: "Inventario",
    VENDOR_OVERVIEW_TABLE_HEADER_4: "Precio",
    VENDOR_OVERVIEW_TABLE_HEADER_5: "Ventas",
    VENDOR_OVERVIEW_TABLE_HEADER_6: "Valor de KwikCash",
    SHOP_BY_CATEGORY: "Comprar por categorías",
    NEWEST_PRODUCTS: "Productos más nuevos",
    PRODUCT_YOU_MIGHT_LIKE: "Productos que podrían gustarte",
    HIGHEST_KCASH: "1Cash más alto",
    HIGHEST_INS_CASHBACK: "Cashback instantáneo más alto",
    SEE_ALL: "Ver todo",
    NEW_BRANDS_ON_KWIK: "Nuevas marcas en Kwik",
    SHOP_BY_BRAND: "Comprar por marca",
    SHOPPING_EMAIL_TITLE1: "¿Quieres saber cuándo se lanzan nuevas marcas?",
    SHOPPING_EMAIL_DESC1:
      "Recibe una notificación cada vez que se lancen nuevas marcas en Kwik y sé el primero en conseguir un enlace",
    SHOPPING_EMAIL_TITLE2: "Tu recomendación llega lejos",
    SHOPPING_EMAIL_DESC2:
      "¡Encontrar un producto que te guste es el primer paso para hacer una recomendación!",
    SHOPPING_EMAIL_DESC3:
      "Encuentra un producto que te guste utilizar y Kwik hará que sea fácil recomendarlo a tus amigos y que te paguen por ello",
    ALL: "Todo",
    RECENT_PURCHASES: "Compras recientes",
    RECENTLY_PURCHASED_PRODUCTS: "Productos comprados recientemente",
    PAGE: "Página",
    OF: "de",
    PREV: "Anterior",
    TOP_SHARED_PRODUCTS: "Top productos compartidos",
    YOUR_PRODUCTS: "Tus productos",
    MOST_EARNED: "Lo más ganado",
    MOST_SHARED: "Los más compartidos",
    SEARCH: "Buscar",
    SEARCH_BY_PRODUCT_NAME: "Buscar por nombre de producto",
    CAMPAIGNS_YOU_HAVENT_JOINED_TEXT: "Aún no te has unido a ninguna campaña:(",
    CAMPAIGNS_FIND_PRODUCTS_OR_CONNECT_TEXT:
      "¡Encuentra productos o conéctate con marcas para conseguir enlaces!",
    CAMPAIGNS_FIND_THE_BRANDS_TEXT: "Encuentra las marcas",
    CAMPAIGNS_SHARES: "Veces compartido",
    CAMAPIGNS_NO_DATA: "Sin datos",
    CAMPAIGNS_LOOKS_LIKE_YOU_HAVE_MESSAGE:
      "Parece que aún no has hecho ninguna referencia o recomendación.",
    CAMPAIGNS_LEARN_MORE_AT: "Más información en",
    CAMPAIGNS_SALES_FROM: "Ventas procedentes de",
    DESCRIPTION: "Description",
    INGREDIENTS: "Ingredients",
    USAGE: "Usage",
    MANUFACTURER: "Manufacturer",
    SHIPPING: "Shipping",
    CONGRATULATIONS: "Order Complete!",
    STANDARD: "Standard",
    FIELD_NAME_IBAN: "IBAN",
    FIELD_NAME_RE_IBAN: "Re-IBAN",
    FIELD_NAME_SORT_CODE: "Sort Code",
    FIELD_NAME_STATE: "State",
    FIELD_NAME_SWIFT_CODE: "Swift Code",
    FIELD_NAME_ZIP_CODE: "Postal Code",
    FIELD_RE_ACCOUNT_NUMBER: "Re-Enter Account Number",
    FIELD_SWIFT_CODE: "SWIFT",
    FIELD_BIC: "BIC",
    FIELD_BIC_CODE_SORT: "BIC/Sort Code",
    FIELD_BANK_BSB: "BSB",
    CANCEL: "Cancel",
    OK: "Ok",
    REFUND: "Refund",
    DELETE: "Delete",
    HEADER_SHOPPING: "Shopping",
    HELP: "Help",
    FIELD_REQUIRED: "This field is required",
    ACCONT_CONFIRM:
      "Changes to this type of account may require you to confirm the account. This will be done by entering the amounts of two small deposits into the account.",
    SS_FOOTER_MAIL_TO: "mailto:support@wer1.com",
    SS_FOOTER_HELLO_EMAIL: "hello@wer1.com",
    ORDER_AGAIN: "Ordene nuevamente",
    VENDOR_SETTINGS_REFERRAL_NAME: "Referrer's Name",
    VENDOR_ACCEPTING_ORDERS_BTN_PREVIOUS: "Previous Step",
    VERSION_DETAIL_01_3_0_2: "Order Date in Order History",
    VERSION_DETAIL_02_3_0_2: "Share page keeps data when changing countries",
    VERSION_DETAIL_03_3_0_2: "Accurate numbers in product categories",
    VERSION_DETAIL_04_3_0_2: "Can’t share removed products",
    VERSION_DETAIL_05_3_0_2: "Campaigns search message",
    VERSION_DETAIL_06_3_0_2: "Available dates for pending Kwikcash",
    VERSION_DETAIL_07_3_0_2: "Post-purchase coin animation for guest users",
    VERSION_DETAIL_08_3_0_2:
      "Image shows in order history for removed products",
    VERSION_DETAIL_09_3_0_2:
      "Terms, Conditions, and Privacy Policy links updated",
    VERSION_DETAIL_10_3_0_2: "Typos!",
    VERSION_DETAIL_11_3_0_2: "Exported reports show countries for brands",
    VERSION_DETAIL_12_3_0_2:
      "Phone Number field is mandatory during brand sign up",
    VERSION_DETAIL_13_3_0_2: "Min & Max on vendor cashouts",
    VERSION_DETAIL_14_3_0_2: "Fixed vendor cash out issues",
    VERSION_DETAIL_15_3_0_2: "Added vendor password reset option",
    USER_SETTING_ACCOUNT_SETTINGS: "Configuraciones de la cuenta",
    USER_SETTING_UPDATE_PROFILE: "Actualización del perfil",
    USER_SETTING_ACCOUNT_INFO: "Informacion de cuenta",
    USER_SETTING_PUBLIC_ACCOUNT_NAME: "Nombre de cuenta pública",
    USER_SETTING_PUBLIC_ACCOUNT_NAME_IS_REQUIRED:
      "Nombre de cuenta pública is required",
    USER_SETTING_USERNAME: "Username",
    USER_SETTING_PUBLIC_ACCOUNT_USERNAME_IS_REQUIRED:
      "Public Account Username is required",
    USER_SETTING_CONTACT_DETAIL: "Detalles del contacto",
    USER_SETTING_EMAIL_ADDRESS: "Dirección de correo electrónico",
    USER_SETTING_UPDATE_EMAIL_ADDRESS:
      "Actualización de la dirección de correo electrónico",
    USER_SETTING_UPDATE: "Actualizar",
    USER_SETTING_PHONE_NUMBER: "Número de teléfono",
    USER_SETTING_UPDATE_PHONE_NUMBER: "Actualizar número de teléfono",
    USER_SETTING_LOGIN: "Acceso",
    USER_SETTING_PASSWORD: "Contraseña",
    USER_SETTING_LAST_UPDATED_AGO: "Last updated {{lastUpdatePwd}} ago",
    USER_SETTING_UPDATE_PASSWORD: "Update Password",
    USER_SETTING_LANGUAGE: "Language",
    USER_SETTING_UPDATE_LANGUAGE: "Update Language",
    USER_SETTING_COUNTRY: "Country",
    USER_SETTING_UPDATE_COUNTRY: "Update Country",
    USER_SETTING_ACCOUNT_DETAILS: "detalles de la cuenta",
    USER_SETTING_THESE_CAN_BE_USED_TO_MAKE_MESSAGE:
      "Estos pueden usarse para asegurarse de que realmente sea usted quien inicia sesión o para contactarlo. Para actualizar estos detalles, comuníquese con nuestro servicio de atención al cliente.",
    USER_SETTING_LEGAL_NAME: "Nombre legal",
    USER_SETTING_RECENT_LOGIN: "Inicio de sesión reciente",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_COMPUTER1:
      "{{sessionNum}} sesiones en computadora con {{system}}",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_COMPUTER2:
      "{{sessionNum}} Sessions on {{system}} Computer",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_MOBILE1:
      "{{sessionNum}} Session on {{system}} mobile phone",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_MOBILE2:
      "{{sessionNum}} Sessions on {{system}} mobile phone",
    USER_SETTING_CHANGE_PASSWORD: "Change Password",
    USER_SETTING_ENTER_THE_DETAILS_BELOW_MESSAGE:
      "Enter the details below to <span>Change password</span> on WeR1.",
    USER_SETTING_ENTER_CURRENT_PASSWORD: "Enter Current Password",
    USER_SETTING_CURRENT_PASSWORD_IS_REQUIRED: "Current Password is required",
    USER_SETTING_INCORRECT_PASSWORD_FORMAT: "Incorrect password format",
    USER_SETTING_YOUR_NEW_PASSWORD: "Your New Password",
    USER_SETTING_NEW_PASSWORD_IS_REQUIRED: "New Password is required",
    USER_SETTING_RE_ENTER_YOUR_NEW_PASSWORD: "Re-Enter Your New Password",
    USER_SETTING_INCONSISTENT_PASSWORDS: "Inconsistent passwords",
    USER_SETTING_THIS_INFORMATION_WILL_BE_MESSAGE:
      'This information will be securely saved as per  the <span><a href="https://help.kwik.com/en/support/solutions/70000319669" target="_blank"><u>Terms of Service & Privacy Policy </u></a></span>',
    USER_SETTING_BACK: "Back",
    USER_SETTING_PASSWORD_SUCCESSFULLY_CHANGED: "Password Successfully Changed",
    USER_SETTING_YOU_CAN_NOW_USE_YOUR_MESSAGE:
      "You can now use your new password to <span>Log in to your account</span>",
    USER_SETTING_CHOOSE_A_LANGUAGE: "Choose a Language",
    USER_SETTING_YOUR_LANGUAGE_WILL_MESSAGE:
      "Your language will save the next time you load Kwik.",
    USER_SETTING_DEFAULT: "Default",
    USER_SETTING_SAVE: "Save",
    USER_SETTING_CHOOSE_A_COUNTRY: "Choose a Country",
    USER_SETTING_YOUR_COUNTRY_WILL_MESSAGE:
      "Your Country will save the next time you load Kwik.",
    USER_SETTING_MENU_SAVED_INFORMATION: "Información guardada",
    USER_SETTING_MENU_ADDRESSES: "Direcciones",
    USER_SETTING_MENU_CASH_OUT_METHODS: "Cash Out Methods",
    USER_SETTING_MENU_PRIVACY_SETTINGS: "La configuración de privacidad",
    USER_SETTING_MENU_NOTIFICATION: "Notification",
    USER_SETTING_ADD_ADDRESS: "Añadir dirección",
    USER_SETTING_ZIP_CODE: "Zip code",
    USER_SETTING_EDIT: "Editar",
    USER_SETTING_REMOVE: "Eliminar",
    USER_SETTING_SUBMIT: "Submit",
    USER_SETTING_PHONE_NUMBER2: "Phone Number",
    USER_SETTING_PHONE_NUMBER_IS_REQUIRED: "Phone Number is required",
    USER_SETTING_NAME: "Name",
    USER_SETTING_NAME_IS_REQUIRED: "Name is required",
    USER_SETTING_ADDRESS: "Address",
    USER_SETTING_ADDRESS_IS_REQUIRED: "Address is required",
    USER_SETTING_APARTIMENT_SUITE_ETC_OPTIONAL:
      "Apartment, Suite, Etc. (Optional)",
    USER_SETTING_CITY: "City",
    USER_SETTING_CITY_IS_REQUIRED: "City is required",
    USER_SETTING_STATE: "State",
    USER_SETTING_STATE_IS_REQUIRED: "State is required",
    USER_SETTING_POSTAL_CODE: "Postal Code",
    USER_SETTING_POSTAL_CODE_IS_REQUIRED: "Postal Code is required",
    USER_SETTING_EMAIL: "Email",
    USER_SETTING_EMAIL_IS_REQUIRED: "Email is required",
    USER_SETTING_GET_STARTED_BY_ADDING_MESSAGE:
      "Get started by adding your first <span>cash out</span> method!",
    USER_SETTING_ADD_METHOD: "Add Method",
    USER_SETTING_SHOW_MY_FULL_NAME_IN_WAVES:
      "Mostrar mi nombre completo en ondas",
    USER_SETTING_ALLOW_USERS_TO_SEE_MESSAGE:
      "Permitir a los usuarios ver mi nombre completo en Waves",
    USER_SETTING_ALLOW_OTHER_USERS_TO_MESSAGE_ME:
      "Permitir que otros usuarios me envíen mensajes",
    USER_SETTING_COMING_SOON: "Muy pronto",
    USER_SETTING_SUBSCRIBE_TO_KWIK_NEWSLETTER: "Subscribe to Kwik Newsletter",
    USER_SETTING_ALL_WE_DO_IS_LET_MESSAGE:
      "All we do is let you know when we make your life better!",
    USER_SETTING_SUBSCRIBE_TO_NEWSLETTERS:
      "Subscribe To Newsletters From Vendors I Have Purchased From",
    USER_SETTING_AUTOMATICALLY_GET_MESSAGE:
      "Automatically get signed up for newsletters from the brands you bought from.",
    USER_SETTING_ALLOW_OTHER_USERS_MESSAGE:
      "Allow Other Users To See My Profile Photo In Their Waves",
    USER_SETTING_IF_ON_OTHERS_CAN_MESSAGE:
      "If on, others can see your profile photo in their waves.",
    USER_SETTING_DOWNLOAD_MY_DATA: "Descargar mis datos",
    USER_SETTING_YOU_CAN_DOWNLOAD_MESSAGE:
      "Puedes descargar una copia de tus datos en cualquier momento",
    USER_SETTING_REQUEST_TO_DOWNLOAD_MU_DATA:
      "Solicitud para descargar mis datos",
    USER_SETTING_DELETE_MY_DATA: "Eliminar mis datos",
    USER_SETTING_YOU_CAN_DELETE_MESSAGE:
      "Eliminar los datos almacenados en mi cuenta",
    USER_SETTING_NOTIFICATION_SETTINGS: "Configuración de las notificaciones",
    USER_SETTING_NOTIFY_ME_ON: "Notificarme el",
    USER_SETTING_FINANCE: "Finanzas",
    USER_SETTING_CASHOUT_ALERTS: "Alertas de retiro",
    USER_SETTING_NOTIFY_ME_ON_EVERY_CASHOUT: "Notificarme en cada retiro",
    USER_SETTING_NEW_BANK_ACCOUNT_ADDED: "Nueva cuenta bancaria agregada",
    USER_SETTING_NOTIFY_ME_WHEN_A_NEW_BANK_ACCOUNT_IS_ADDED:
      "Notificarme cuando se agregue una nueva cuenta bancaria",
    USER_SETTING_KWIKCASH_CLEARS: "1 Liquidación de efectivo",
    USER_SETTING_WAVES: "Ondas",
    USER_SETTING_WHEN_SOMEONE_JOINS_MY_WAVES:
      "Cuando alguien se une a mis olas",
    USER_SETTING_NOTIFY_ME_EVERY_TIME_SOMEONE_JOINS_MY_WAVES:
      "Notificarme cada vez que alguien se una a mis olas",
    USER_SETTING_MARKETING: "Marketing",
    USER_SETTING_SIGN_ME_UP_FOR_KWIK_NEWSLETTER:
      "Sign me up for Kwik Newsletter",
    USER_SETTING_GET_UPDATES_ON_THE_RELEASES_MESSAGE:
      "Get updates on the releases, and get important updates that might impact your account",
    USER_SETTING_ALLOW_BRANDS_MESSAGE:
      "Allow Brands to Send Me Their Newsletter",
    USER_SETTING_ALLOW_THE_BRANDS_OF_THE_MESSAGE:
      "Allow the brands of the campaigns I am in to send me newsletters by default",
    USER_SETTING_SHOPPING: "Shopping",
    USER_SETTING_NEW_BRANDS_ON_KWIK: "New Brands on Kwik",
    USER_SETTING_TRENDING_DEALS: "Trending Deals",
    USER_SETTING_SETTINGS: "Ajustes",
    USER_SETTING_ANY_SETTINGS_CHANGES_ARE_MADE:
      "Se realizan todos los cambios de configuración.",
    USER_SETTING_NOTIFY_ME_WHEN_ANY_SETTINGS_ARE_CHANGED:
      "Notificarme cuando se cambie alguna configuración",
    USER_SETTING_LANGUAGE_CHANGED: "Idioma cambiado",
    USER_SETTING_NOTIFY_ME_WHEN_THE_LANGUAGE_CHANGES:
      "Notificarme cuando el idioma cambie",
    USER_REGISTER_LEGAL_NAME: "Legal Name",
    USER_REGISTER_PLEASE_INPUT_YOUR_ADDRESS_LEGAL_NAME:
      "Please input your Address Legal Name",
    MINIMUM_8_CHARACTERS_FOR_SECURE_PASSWORD:
      "Mínimo 8 caracteres para contraseña segura.",
    UPPER_CASE: "Mayúsculas",
    LOWER_CASE: "minúsculas",
    ONE_NUMBERS: "un número",
    A_8_CHARC: "8 caracteres",
    HEY_WE_MISS_YOU2: "Nosotros te extrañamos",
    SAVE_YOUR_INFO_TEXT:
      "Esperábamos que volvieras, por eso decidimos guardar tu información.",
    DASHBOARD_TODAY: "Hoy",
    DASHBOARD_PAST_WEEK: "Semana pasada",
    DASHBOARD_PAST_MONTH: "El mes pasado",
    DASHBOARD_PAST_YEAR: "Año pasado",
    AMBASSADORS_DETAIL_WAVES_TITLE: "Ondas",
    SHOPPING_BUTTON_QUICK_SHARE: "Compartir ahora",
    MOST_POPULAR: "Más popular",
    MOST_RECENT_SHARE: "Acciones más recientes",
    MOST_SHARED: "Más compartido",
    MOST_EARNED: "Más ganado",
    YOUR_PRODUCTS: "Tus productos",
    WALK_THROUGH: "Ensayar",
    KWIKCASH_ADD_PAYMENT_BTN_NEXT_STEP: "Próximo paso",
    DASHBOARD_TOP_CAMPAIGN: "Campaña principal",
    DASHBOARD_SHARE_BRANDS: "Compartir marcas",
    SHAYDAIRC:
      "¡Vea cómo todas sus referencias directas e indirectas componen sus oleadas y aumente sus oleadas de ganancias!",
    NOTIFICATION_NAV_NOTIFICATIONS: "Notificaciones",
    LEARN_ABOUT_KWIK_PROFILE_SECTION: "Más información sobre Wer1",
    NOTIFICATION_SELECT_RECENT: "Reciente",
    NOTIFICATION_SELECT_OLDER: "Más viejo",
    AMBASSADORS_FILTER_ALL_TEXT: "Todo",
    NOTIFICATION_CHECKBOX_ALL: "Todo",
    INVITE_A_FRIEND: "Invitar a un amigo",
    LOYALTY_POINTS_REWARDS: "Rewards",
    LOYALTY_POINTS: "Puntos de lealtad",
    LOYALTY_SUBTEXT:
      "¡Vea todos los puntos de recompensa que acumuló de diferentes marcas y campañas, así como las bonificaciones que tienen!",
    POINTS: "Puntos",
    SHARE_BRAND: "Compartir marca",
    VIEW_ALL_PRODUCTS: "Ver todos los productos",
    WAYS_TO_REDEEM: "Formas de canjear",
    WAYS_TO_EARN: "Formas de ganar",
    FREE_PRODUCT: "Producto gratuito",
    AMBASSADORS_DETAIL_WAVES_SHOW_ALL: "Mostrar todo",
    SHARE_ORDER: "Orden de acciones",
    BACK_TO_ORDERS: "Volver a Pedidos",
    SHIPPING_DETAILS: "Detalles de envío",
    STATUS: "Estado",
    SHIP_LOCATION: "Ubicación del barco",
    ORDER_DATE: "Fecha de orden",
    HEADER_LAYER_EDIT_PROFILE: "Editar perfil",
    KWIKCASH_BALANCE_PROFILE_SECTION: "1Saldo en efectivo",
    ACCOUNT_SETTING: "Configuraciones de la cuenta",
    USER_SETTING_BIRTHDAY: "Cumpleaños",
    BRAND: "Marca",
  },
};
